import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { collection, onSnapshot, getDocs, query, where, doc, getDoc, addDoc, writeBatch, setDoc, deleteDoc } from 'firebase/firestore';
import { ref, getDownloadURL, listAll, getStorage, uploadBytes, deleteObject } from 'firebase/storage';
import { database, storage } from './firebaseConfig';
import { getFirestore } from 'firebase/firestore';
import { auth } from './firebaseConfig';
import { getCustomerListRef, getMachinesRef, getOperatorsRef, getPuantajlarRef } from '../utils/databaseOperations';
import { COLLECTIONS, CUSTOMER_STATUS, COLLECTION_PATHS } from '../utils/constants';
import { toTurkishUpperCase } from '../utils/searchUtils';
import useModalEnterNavigation from '../hooks/useModalEnterNavigation';
import { runTransaction } from 'firebase/firestore';

import DatePicker, { registerLocale } from 'react-datepicker';
import tr from 'date-fns/locale/tr';
import 'react-datepicker/dist/react-datepicker.css';
import './Puantajlar.css';

import Select from 'react-select';
import { debounce } from 'lodash';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { PDFDocument } from 'pdf-lib';
import { Modal, TextField, Button, IconButton, Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';

// Tarih yardımcıları
import { parseFlexible, toIsoUtcString, formatTrDateTime, formatTrDateOnly } from '../utils/hopsDate';

// PDF yeniden oluşturma fonksiyonları
import { regeneratePuantajPDF, deleteOldPDF } from '../utils/pdfGenerator';

// PDF Önizleme Modal'ı
import PDFPreviewModal from './PDFPreviewModal';

// Müşteri ekleme modal'ı
import AddCustomerModal from './AddCustomerModal';

// Müşteri seçim tablosu
import CustomerSelectionTable from './CustomerSelectionTable';

// EditPuantajModal
import EditPuantajModal from './EditPuantajModal';

import * as pdfjsLib from 'pdfjs-dist/build/pdf';
pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';

registerLocale('tr', tr);

// Styled components
const StyledIconButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0.5),
  marginLeft: theme.spacing(1),
  width: '30px',
  height: '30px',
}));

const parseDate = (dateString) => {
  return parseFlexible(dateString) || new Date();
};

/**
 * Çalışma süresini dakikaya çeviren fonksiyon - Birden fazla format destekler
 * iOS HopsPlus ile AYNI MANTIK
 * 
 * Desteklenen formatlar:
 * - "2:30" veya "1:00" (HH:MM)
 * - "1 saat 0 dakika" veya "2 saat 30 dakika"
 * - "8.5" veya "8,5" (ondalık saat)
 * - "60" (sadece sayı - dakika olarak)
 */
const parseWorkingTime = (timeString) => {
  if (!timeString || timeString.trim() === '') {
    console.log('🕐 parseWorkingTime: Boş string, 0 döndürülüyor');
    return 0;
  }

  const input = timeString.toString().trim();
  console.log(`🕐 parseWorkingTime input: '${input}'`);

  // Format 1: "2:30" veya "1:00" (HH:MM)
  if (input.includes(':') && !input.toLowerCase().includes('saat')) {
    const parts = input.split(':');
    if (parts.length === 2) {
      const hours = parseInt(parts[0].trim(), 10) || 0;
      const minutes = parseInt(parts[1].trim(), 10) || 0;
      const total = hours * 60 + minutes;
      console.log(`🕐 Format 1 (HH:MM) parsed: ${total} dakika`);
      return total;
    }
  }

  // Format 2: "1 saat 0 dakika" veya "2 saat 30 dakika"
  if (input.toLowerCase().includes('saat')) {
    let hours = 0;
    let minutes = 0;

    // "X saat" kısmını bul
    const saatMatch = input.toLowerCase().match(/(\d+)\s*saat/);
    if (saatMatch) {
      hours = parseInt(saatMatch[1], 10) || 0;
    }

    // "X dakika" veya "X dk" kısmını bul
    const dakikaMatch = input.toLowerCase().match(/(\d+)\s*(dakika|dk)/);
    if (dakikaMatch) {
      minutes = parseInt(dakikaMatch[1], 10) || 0;
    }

    const total = hours * 60 + minutes;
    console.log(`🕐 Format 2 (X saat Y dakika) parsed: ${hours} saat ${minutes} dakika = ${total} dakika`);
    return total;
  }

  // Format 3: "8.5" veya "8,5" (ondalık saat)
  const normalized = input.replace(',', '.');
  const decimalHours = parseFloat(normalized);
  if (!isNaN(decimalHours) && normalized.includes('.')) {
    const total = Math.round(decimalHours * 60);
    console.log(`🕐 Format 3 (decimal) parsed: ${total} dakika`);
    return total;
  }

  // Format 4: Sadece sayı (dakika olarak kabul et)
  const justNumber = parseInt(input, 10);
  if (!isNaN(justNumber) && !input.includes('.') && !input.includes(',')) {
    console.log(`🕐 Format 4 (just number) parsed: ${justNumber} dakika`);
    return justNumber;
  }

  console.log('🕐 ❌ Hiçbir format eşleşmedi! 0 döndürülüyor');
  return 0;
};

const Puantajlar = ({ userData }) => {
  // Mevcut durumlar...
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedPdfs, setSelectedPdfs] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [userEmail, setUserEmail] = useState('');
  const [companyName, setCompanyName] = useState('');

  // Pagination state'leri
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(20); // Sayfa başına 20 puantaj

  // eslint-disable-next-line no-unused-vars
  const [customerOptions, setCustomerOptions] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [machineOptions, setMachineOptions] = useState([]);
  const [selectedMachines, setSelectedMachines] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [operatorOptions, setOperatorOptions] = useState([]);
  const [selectedOperators, setSelectedOperators] = useState([]);

  const [isHakedisPopupOpen, setIsHakedisPopupOpen] = useState(false);
  const [unitRate, setUnitRate] = useState('');
  const [totalHakedis, /*setTotalHakedis*/] = useState(''); // Commented out

  const [calculatedTotalHours, /*setCalculatedTotalHours*/] = useState('');
  // const [calculatedTotalMinutes, setCalculatedTotalMinutes] = useState(0); // Comment this out

  // const [isCalculating, setIsCalculating] = useState(false); // Commented out

  // eslint-disable-next-line no-unused-vars
  const [shantiyeler, setShantiyeler] = useState([]);

  const [shantiyeChanges, setShantiyeChanges] = useState({});

  const [successMessage, setSuccessMessage] = useState('');
  const [alertOpen, setAlertOpen] = useState(false);

  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);

  const [customerMap, setCustomerMap] = useState({});

  const [selectedPuantaj, setSelectedPuantaj] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [puantajToDelete, setPuantajToDelete] = useState(null);
  
  // PDF yeniden oluşturma durumları
  const [isPdfRegenerating, setIsPdfRegenerating] = useState(false);
  const [isPdfRegeneratingLoading, setIsPdfRegeneratingLoading] = useState(false); // Ayrı loading modal için
  const loadingTimeoutRef = useRef(null); // Loading timeout referansı - ref olarak değiştir
  const [userInfo, setUserInfo] = useState({});
  
  // userData prop'u değiştiğinde userInfo'yu güncelle
  useEffect(() => {
    if (userData && Object.keys(userData).length > 0) {
      console.log('🔄 Puantajlar: userData prop\'u değişti, userInfo güncelleniyor:', userData);
      setUserInfo(prevInfo => ({
        ...prevInfo,
        companyName: userData.companyName || userData.company || prevInfo.companyName || 'Firma Adı',
        companyAddress: userData.address || prevInfo.companyAddress || 'Firma Adresi',
        companyPhone: userData.phoneNumber || prevInfo.companyPhone || 'Telefon',
        logoUrl: userData.logoUrl || prevInfo.logoUrl || null,
        showPuantajPrice: userData.puantajfiyat === 'yes'
      }));
    }
  }, [userData]);
  
  // PDF Önizleme Modal durumları
  const [isPdfPreviewOpen, setIsPdfPreviewOpen] = useState(false);
  const [previewPdfUrl, setPreviewPdfUrl] = useState(null);
  const [pendingPuantajUpdate, setPendingPuantajUpdate] = useState(null);
  const [pendingFormData, setPendingFormData] = useState(null);
  const [pendingHoursDifference, setPendingHoursDifference] = useState(0);
  const [pendingTempFileName, setPendingTempFileName] = useState(null);
  const [pendingOriginalFileName, setPendingOriginalFileName] = useState(null);
  const [pendingTempStoragePath, setPendingTempStoragePath] = useState(null);
  const [pendingOriginalStoragePath, setPendingOriginalStoragePath] = useState(null);
  
  // Yeni müşteri ekleme modal'ı için state'ler
  const [isAddCustomerModalOpen, setIsAddCustomerModalOpen] = useState(false);
  const [newCustomerFromPuantaj, setNewCustomerFromPuantaj] = useState('');
  
  // Müşteri seçim tablosu için state'ler
  const [isCustomerSelectionOpen, setIsCustomerSelectionOpen] = useState(false);
  const [allCustomersForSelection, setAllCustomersForSelection] = useState([]);
  
  // Makine seçim tablosu için state'ler
  const [isMachineSelectionOpen, setIsMachineSelectionOpen] = useState(false);
  
  // Operatör seçim tablosu için state'ler
  const [isOperatorSelectionOpen, setIsOperatorSelectionOpen] = useState(false);
  
  // Form verileri state'i (re-render'da kaybolmaması için)
  const [editFormData, setEditFormData] = useState({});

  const formRefs = useRef({
    'Müşteri Adı': useRef(),
    'Makine İsmi': useRef(),
    'Operatör Adı': useRef(),
    'Tarih': useRef(),
    '1. Başlangıç Saati': useRef(),
    '1. Bitiş Saati': useRef(),
    '2. Başlangıç Saati': useRef(),
    '2. Bitiş Saati': useRef(),
    'Yetkili Adı': useRef(),
    'Çalışma Detayı': useRef()
  });

  // Modal Enter navigasyonu
  useModalEnterNavigation(isEditModalOpen, formRefs.current);

  // Artık controlled component kullandığımız için form restore useEffect'ine gerek yok

  const debouncedSetStartDate = useMemo(
    () => debounce((date) => setStartDate(date), 300),
    [setStartDate]
  );

  const debouncedSetEndDate = useMemo(
    () => debounce((date) => setEndDate(date), 300),
    [setEndDate]
  );

  const getSantiyeNameByCariCode = useCallback((cariCode) => {
    const santiye = shantiyeler.find((s) => s['cariCode'] === cariCode);
    return santiye ? santiye['Müşteri Adı'] : 'Silinmiş Müşteri';
  }, [shantiyeler]);

  // Saat formatını dönüştüren yardımcı fonksiyon - TÜM FORMATLARI DESTEKLİYOR
  const formatTimeForInput = useCallback((timeStr) => {
    if (!timeStr) return '';
    
    // Sadece rakam ve : karakterlerini temizle
    const cleanTime = timeStr.toString().replace(/[^\d:]/g, '');
    
    // : ile ayır
    const parts = cleanTime.split(':');
    if (parts.length !== 2) return '';
    
    let [hours, minutes] = parts;
    
    // Saat kısmını normalize et (01, 02, 03... 23)
    hours = hours.padStart(2, '0');
    if (parseInt(hours) > 23) return ''; // Geçersiz saat
    
    // Dakika kısmını normalize et (00, 01, 02... 59)
    minutes = minutes.padStart(2, '0');
    if (parseInt(minutes) > 59) return ''; // Geçersiz dakika
    
    return `${hours}:${minutes}`;
  }, []);

  // Saat string'ini ondalık saate çeviren fonksiyon (12:30 -> 12.5)
  const parseTime = useCallback((timeStr) => {
    if (!timeStr) return 0;
    
    // Saat formatını normalize et
    const normalizedTime = formatTimeForInput(timeStr);
    if (!normalizedTime) return 0;
    
    const [hours, minutes] = normalizedTime.split(':').map(Number);
    return hours + minutes / 60;
  }, [formatTimeForInput]);

  // Yeni müşteri adının mevcut müşteriler listesinde olup olmadığını kontrol eden fonksiyon
  const checkIfCustomerExists = useCallback((customerName) => {
    if (!customerName || !customerOptions) return true; // Boşsa var varsay
    
    const trimmedName = customerName.trim();
    return customerOptions.some(customer => 
      customer.value.toLowerCase() === trimmedName.toLowerCase()
    );
  }, [customerOptions]);

  // Filtre verilerini yükleme useEffect
  // Filtre verilerini getiren fonksiyon - component seviyesinde tanımla
  const fetchFilterData = async () => {
    const currentUser = auth.currentUser;
    if (!currentUser || !currentUser.email) {
      console.error('Kullanıcı bilgisi alınamadı');
      return;
    }

    try {
      // Referansları al
      const customerListRef = collection(database, `users/${currentUser.email}/customerList`);
      const machinesRef = collection(database, `users/${currentUser.email}/machines`);
      const operatorsRef = collection(database, `users/${currentUser.email}/operators`);
      
      // Verileri çek
      const [customerSnapshot, machineSnapshot, operatorSnapshot] = await Promise.all([
        getDocs(customerListRef),
        getDocs(machinesRef),
        getDocs(operatorsRef)
      ]);

      // Müşteri listesini yükle
      const customerOptionsArray = customerSnapshot.docs
        .map(doc => {
          const data = doc.data();
          const customerName = data['Müşteri Adı']?.trim() || '';
          const cariCode = data['cariCode']?.trim() || '';
          return {
            value: customerName,
            label: `${customerName} / ${cariCode}`,
            searchValue: customerName.toLowerCase()
          };
        })
        .filter(option => option.value)
        .sort((a, b) => a.label.localeCompare(b.label));
      setCustomerOptions(customerOptionsArray);
      console.log('Müşteri seçenekleri yüklendi:', customerOptionsArray);
      
      // Müşteri map'i oluştur
      const customerMapObj = {};
      customerSnapshot.docs.forEach(doc => {
        const data = doc.data();
        if (data['Müşteri Adı'] && data['cariCode']) {
          customerMapObj[data['cariCode']] = data['Müşteri Adı'];
        }
      });
      setCustomerMap(customerMapObj);
      
      // Şantiye listesini yükle
      const shantiyelerArray = customerSnapshot.docs
        .map(doc => doc.data())
        .filter(data => data['Şantiye'] === true);
      setShantiyeler(shantiyelerArray);

      // Makine listesini yükle
      const machineOptionsArray = machineSnapshot.docs
        .map(doc => {
          const data = doc.data();
          const machineName = data['MakineAdı']?.trim() || '';
          return {
            value: machineName,
            label: machineName,
            hourlyRate: Number(data['BirimFiyat']) || 0,
            searchValue: machineName.toLowerCase()
          };
        })
        .filter(option => option.value)
        .sort((a, b) => a.label.localeCompare(b.label));
      setMachineOptions(machineOptionsArray);
      console.log('Makine seçenekleri yüklendi:', machineOptionsArray);

      // Operatör listesini yükle
      const operatorOptionsArray = operatorSnapshot.docs
        .map(doc => {
          const data = doc.data();
          const firstName = data['name']?.trim() || '';
          const lastName = data['surname']?.trim() || '';
          // Ad ve soyad varsa birleştir, yoksa sadece adı kullan
          const fullName = lastName ? `${firstName} ${lastName}` : firstName;
          
          return {
            value: fullName,
            label: fullName,
            searchValue: fullName.toLowerCase()
          };
        })
        .filter(option => option.value)
        .sort((a, b) => a.label.localeCompare(b.label));
      setOperatorOptions(operatorOptionsArray);
      console.log('Operatör seçenekleri yüklendi:', operatorOptionsArray);

    } catch (error) {
      console.error('Filtre verileri yüklenirken hata:', error);
    }
  };

  useEffect(() => {
    const currentUser = auth.currentUser;
    if (!currentUser || !currentUser.email) {
      setError("Kullanıcı bilgisi alınamadı. Lütfen tekrar giriş yapın.");
      setLoading(false);
      return;
    }
    
    fetchFilterData();
  }, []);

  useEffect(() => {
    // Mevcut kullanıcı bilgisini al
    const currentUser = auth.currentUser;
    if (!currentUser || !currentUser.email) {
      setError("Kullanıcı bilgisi alınamadı. Lütfen tekrar giriş yapın.");
      setLoading(false);
      return;
    }

    setUserEmail(currentUser.email);

    // Firma bilgisini al
    const fetchCompanyInfo = async () => {
      try {
        const userDocRef = doc(database, 'users', currentUser.email);
        const userDoc = await getDoc(userDocRef);
        
        if (userDoc.exists()) {
          const userData = userDoc.data();
          setCompanyName(userData.companyName || 'Firma Adı Yok');
          
          // PDF oluşturma için kullanıcı bilgilerini kaydet
          setUserInfo({
            companyName: userData.companyName || userData.company || 'Firma Adı',
            companyAddress: userData.address || 'Firma Adresi',
            companyPhone: userData.phoneNumber || 'Telefon',
            logoUrl: userData.logoUrl || null,
            showPuantajPrice: userData.puantajfiyat === 'yes'
          });
        }
      } catch (error) {
        console.error('Firma bilgileri alınamadı:', error);
      }
    };

    fetchCompanyInfo();

    const db = database;
    // Sadece kullanıcının kendi timeSheets koleksiyonuna erişim
    const puantajlarRef = collection(db, `users/${currentUser.email}/timeSheets`);

    const unsubscribe = onSnapshot(puantajlarRef, async (snapshot) => {
      try {
        const puantajlarData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // Puantaj verilerinin yapısını kontrol et (imza alanları için)
        if (puantajlarData.length > 0) {
          console.log('🔍 İlk puantaj verisinin alanları:', Object.keys(puantajlarData[0]));
          console.log('🔍 İmza ile ilgili alanlar:', 
            Object.keys(puantajlarData[0]).filter(key => 
              key.toLowerCase().includes('imza') || 
              key.toLowerCase().includes('signature') ||
              key.toLowerCase().includes('sign')
            )
          );
        }

        // Müşteri verilerini al
        const customerListRef = collection(db, `users/${currentUser.email}/customerList`);
        const customerSnapshot = await getDocs(customerListRef);
        const customerData = customerSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        console.log("Çekilen puantaj verileri:", puantajlarData.length, "adet");

        // PDF'leri hem eski (pdfs/) hem yeni (pdfs/{userEmail}/) klasörlerden al
        let allPdfItems = [];
        
        try {
          // 1. Eski format: pdfs/ klasörü
          console.log('📁 Eski format PDF listesi alınıyor: pdfs/');
          const oldPdfListRef = ref(storage, 'pdfs/');
          const oldPdfResult = await listAll(oldPdfListRef);
          console.log(`✅ Eski format: ${oldPdfResult.items.length} PDF bulundu`);
          allPdfItems = [...oldPdfResult.items];
        } catch (error) {
          console.warn('⚠️ Eski format PDF listesi alınamadı:', error);
        }
        
        try {
          // 2. Yeni format: pdfs/{userEmail}/ klasörü
          console.log(`📁 Yeni format PDF listesi alınıyor: pdfs/${currentUser.email}/`);
          const newPdfListRef = ref(storage, `pdfs/${currentUser.email}/`);
          const newPdfResult = await listAll(newPdfListRef);
          console.log(`✅ Yeni format: ${newPdfResult.items.length} PDF bulundu`);
          allPdfItems = [...allPdfItems, ...newPdfResult.items];
        } catch (error) {
          console.warn('⚠️ Yeni format PDF listesi alınamadı:', error);
        }

        // Aynı dosya adı hem pdfs/ hem pdfs/{email}/ içinde varsa iki satır oluşuyordu (mobilde tek kayıt).
        const pdfByFileName = new Map();
        for (const itemRef of allPdfItems) {
          pdfByFileName.set(itemRef.name, itemRef);
        }
        allPdfItems = Array.from(pdfByFileName.values());
        
        console.log(`🔄 Toplam ${allPdfItems.length} PDF (tekrarsız dosya adı)`);
        const pdfResult = { items: allPdfItems };

        const merged = await Promise.all(
          pdfResult.items.map(async (itemRef) => {
            // Puantaj eşleştirmesini geliştir
            const matchingPuantaj = puantajlarData.find(
              (puantaj) => puantaj['Sözleşme Numarası'] === itemRef.name ||
                          puantaj['SozlesmeNumarasi'] === itemRef.name ||
                          puantaj['sozlesmeNumarasi'] === itemRef.name ||
                          puantaj['sozlesme_numarasi'] === itemRef.name ||
                          puantaj['sozlesme'] === itemRef.name
            );

            // Eğer puantaj bu kullanıcıya ait değilse, listeleme
            if (!matchingPuantaj) return null;

            let customerName = '-';
            let cariCode = '-';
            let workDetail = '-';
            let authorizedPerson = '-';

            if (matchingPuantaj) {
              // Müşteri adı kontrolü
              customerName = matchingPuantaj['Müşteri Adı']?.trim() || 
                           matchingPuantaj['MusteriAdi']?.trim() || 
                           matchingPuantaj['musteriAdi']?.trim() || '-';

              // Cari kod kontrolü
              cariCode = matchingPuantaj['Cari Kodu']?.trim() || 
                        matchingPuantaj['CariKodu']?.trim() || 
                        matchingPuantaj['cariKodu']?.trim() || 
                        matchingPuantaj['cariCode']?.trim() || '-';

              // Çalışma detayı kontrolü
              workDetail = matchingPuantaj['Çalışma Detayı']?.trim() || 
                          matchingPuantaj['CalismaDetayi']?.trim() || 
                          matchingPuantaj['calismaDetayi']?.trim() || '-';

              // Yetkili kişi kontrolü
              authorizedPerson = matchingPuantaj['Yetkili Adı']?.trim() || 
                               matchingPuantaj['YetkiliAdi']?.trim() || 
                               matchingPuantaj['yetkiliAdi']?.trim() || '-';

              // Cari kod bulunamadıysa müşteri listesinden bul
              if (!cariCode || cariCode === '-') {
                  const matchingCustomer = customerData.find(
                  customer => customer['Müşteri Adı']?.trim().toLowerCase() === customerName.toLowerCase()
                  );
                  if (matchingCustomer) {
                    cariCode = matchingCustomer.cariCode || matchingCustomer['Cari Kodu'] || '-';
                }
              }

              console.log('Puantaj eşleştirme detayları:', {
                customerName,
                cariCode,
                workDetail,
                authorizedPerson,
                originalData: matchingPuantaj
              });
            }

            return {
              pdfName: itemRef.name,
              pdfRef: itemRef,
              customerName,
              cariCode,
              'Çalışma Detayı': workDetail,
              'Yetkili Adı': authorizedPerson,
              ...(matchingPuantaj || {}),
            };
          })
        );

        // Null değerleri filtrele (bu kullanıcıya ait olmayan puantajları dışarıda bırak)
        const filteredMerged = merged.filter(item => item !== null);

        console.log("Birleştirilmiş veri:", filteredMerged.length, "adet");
        
        setAllData(filteredMerged);
        setFilteredData(filteredMerged);
        setLoading(false);
      } catch (error) {
        console.error('Veri yükleme hatası:', error);
        setError('Veriler yüklenirken bir hata oluştu');
        setLoading(false);
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  // Şantiye değişikliklerini izleyen yeni useEffect
  useEffect(() => {
    const db = database;
    const shantiyeRef = collection(db, `users/${auth.currentUser?.email}/customerList`);
    const shantiyeQuery = query(shantiyeRef, where('Şantiye', '==', true));

    const unsubscribe = onSnapshot(shantiyeQuery, (snapshot) => {
      snapshot.docChanges().forEach((change) => {
        if (change.type === 'modified') {
          const newData = change.doc.data();
          setShantiyeChanges(prev => ({
            ...prev,
            [change.doc.id]: {
              oldName: change.doc.data().OldName || newData['Şantiye Adı'],
              newName: newData['Şantiye Adı'],
              newCariCode: newData['Şantiye Cari Kodu'],
            }
          }));
        }
      });
    });

    return () => unsubscribe();
  }, []);

  // Sıralama Durumları
  const [order, setOrder] = useState('desc'); // 'asc' veya 'desc' - En yeni tarihler üstte
  const [orderBy, setOrderBy] = useState('Tarih'); // Varsayılan sıralama sütunu - Tarihe göre

  // Sıralama Fonksiyonu
  const handleSort = (column) => {
    const isAsc = orderBy === column && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(column);
  };

  // Veriyi Sıralama
  const sortedData = useMemo(() => {
    const comparator = (a, b) => {
      let aValue = a[orderBy];
      let bValue = b[orderBy];

      // Tarih sütunu özel işleniyor
      if (orderBy === 'Tarih') {
        aValue = parseDate(aValue);
        bValue = parseDate(bValue);
        if (aValue < bValue) return order === 'asc' ? -1 : 1;
        if (aValue > bValue) return order === 'asc' ? 1 : -1;
        return 0;
      }

      // Diğer sütunlar string karşılaştırması
      if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
      }
      if (typeof bValue === 'string') {
        bValue = bValue.toLowerCase();
      }

      if (aValue < bValue) return order === 'asc' ? -1 : 1;
      if (aValue > bValue) return order === 'asc' ? 1 : -1;
      return 0;
    };

    return [...filteredData].sort(comparator);
  }, [filteredData, order, orderBy]);

  // Pagination hesaplamaları
  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentPageData = sortedData.slice(startIndex, endIndex);

  // Sayfa değiştirme fonksiyonları
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    // Seçili PDF'ler korunuyor - sayfa değişse bile seçimler kalıyor
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      handlePageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      handlePageChange(currentPage + 1);
    }
  };

  // Filtre değiştiğinde ilk sayfaya dön ve seçimleri kontrol et
  useEffect(() => {
    // Sadece filtre değiştiğinde sayfa 1'e dön
    setCurrentPage(1);
    
    // Seçili PDF'lerin hala mevcut olup olmadığını kontrol et
    if (selectedPdfs.length > 0) {
      const availablePdfNames = filteredData.map(item => item.pdfName);
      const validSelections = selectedPdfs.filter(pdfName => 
        availablePdfNames.includes(pdfName)
      );
      
      // Eğer bazı seçimler artık mevcut değilse, sadece geçerli olanları tut
      if (validSelections.length !== selectedPdfs.length) {
        console.log('🔍 Filtre değişti, seçimler güncelleniyor:', {
          'Önceki seçim sayısı': selectedPdfs.length,
          'Geçerli seçim sayısı': validSelections.length,
          'Kaldırılan seçimler': selectedPdfs.filter(pdf => !validSelections.includes(pdf))
        });
        setSelectedPdfs(validSelections);
      }
    }
  }, [filteredData.length, filteredData]); // selectedPdfs dependency'sini kaldırdık

  // Seçim değiştiğinde sayfa değişmemesi için ayrı useEffect
  useEffect(() => {
    // Seçim yapıldığında sayfa değişmez, sadece seçimler güncellenir
    if (selectedPdfs.length > 0) {
      const availablePdfNames = filteredData.map(item => item.pdfName);
      const validSelections = selectedPdfs.filter(pdfName => 
        availablePdfNames.includes(pdfName)
      );
      
      // Eğer bazı seçimler artık mevcut değilse, sadece geçerli olanları tut
      if (validSelections.length !== selectedPdfs.length) {
        console.log('🔍 Seçim güncelleniyor (sayfa değişmeden):', {
          'Önceki seçim sayısı': selectedPdfs.length,
          'Geçerli seçim sayısı': validSelections.length,
          'Kaldırılan seçimler': selectedPdfs.filter(pdf => !validSelections.includes(pdf))
        });
        setSelectedPdfs(validSelections);
      }
    }
  }, [selectedPdfs, filteredData]);

  // Filtreleme Fonksiyonu
  const applyFilters = useCallback(() => {
    let filtered = allData;

    if (startDate && endDate) {
      filtered = filtered.filter((item) => {
        const itemDate = parseDate(item['Tarih']);
        // Başlangıç tarihi (dahil)
        const startOfDay = new Date(startDate);
        startOfDay.setHours(0, 0, 0, 0);
        // Bitiş tarihi (dahil)
        const endOfDay = new Date(endDate);
        endOfDay.setHours(23, 59, 59, 999);
        
        return itemDate >= startOfDay && itemDate <= endOfDay;
      });
    }

    if (selectedCustomers.length > 0) {
      filtered = filtered.filter((item) => {
        const customerName = item.customerName || item['Müşteri Adı'] || item['MusteriAdi'] || item['musteriAdi'] || '';
        return selectedCustomers.some((selected) => 
          selected.value.toLowerCase() === customerName.toLowerCase()
        );
      });
    }

    if (selectedMachines.length > 0) {
      filtered = filtered.filter((item) => {
        const machineName = item['Makine İsmi'] || item['MakineIsmi'] || item['makineIsmi'] || '';
        return selectedMachines.some((selected) => 
          selected.value.toLowerCase() === machineName.toLowerCase()
        );
      });
    }

    if (selectedOperators.length > 0) {
      filtered = filtered.filter((item) => {
        const operatorName = item['Operatör Adı'] || item['OperatorAdi'] || item['operatorAdi'] || '';
        return selectedOperators.some((selected) => 
          selected.value.toLowerCase() === operatorName.toLowerCase()
        );
      });
    }

    console.log("Filtrelenmiş veri:", filtered);
    setFilteredData(filtered);
  }, [allData, startDate, endDate, selectedCustomers, selectedMachines, selectedOperators]);

  useEffect(() => {
    applyFilters();
  }, [applyFilters]);

  // Puantaj fiyat hesaplama fonksiyonu
  const calculatePuantajPrice = async (puantajData) => {
    if (!userInfo || !userInfo.showPuantajPrice) {
      console.log('🔍 Fiyat hesaplama atlandı:', {
        'userInfo var mı': !!userInfo,
        'showPuantajPrice': userInfo?.showPuantajPrice
      });
      return null;
    }

    try {
      const machineName = puantajData['Makine İsmi'] || puantajData['MakineIsmi'] || '';
      const customerName = puantajData['Müşteri Adı'] || '';
      const workingTime = puantajData['Toplam Çalışma Süresi'] || puantajData['ToplamCalismaSuresi'] || '0:00';

      const userEmail = auth.currentUser?.email;
      if (!userEmail || !machineName || !customerName) return null;

      const db = database;

      // Önce müşterinin özel saatlik fiyatını kontrol et
      let hourlyRate = 0;
      const customerRef = collection(db, `users/${userEmail}/customerList`);
      const customerQuery = query(customerRef, where('Müşteri Adı', '==', customerName));
      const customerSnapshot = await getDocs(customerQuery);

      // Kamyon puantajı kontrolü - sefer bazlı fiyatlandırma
      const icSeferSayisi = puantajData['İç Sefer Sayısı'] || puantajData['icSeferSayisi'] || 0;
      const disSeferSayisi = puantajData['Dış Sefer Sayısı'] || puantajData['disSeferSayisi'] || 0;
      const isKamyonPuantaji = icSeferSayisi > 0 || disSeferSayisi > 0;
      
      let totalPrice = 0;
      
      if (!customerSnapshot.empty) {
        const customerDoc = customerSnapshot.docs[0];
        const customerData = customerDoc.data();
        
        if (isKamyonPuantaji) {
          // Kamyon puantajı - sefer bazlı fiyatlandırma
          const customerIcSeferFiyati = customerData['Özel İç Sefer Fiyatı'];
          const customerDisSeferFiyati = customerData['Özel Dış Sefer Fiyatı'];
          
          // Müşteri özel sefer fiyatları varsa onları kullan
          let icFiyat = 0;
          let disFiyat = 0;
          
          if (customerIcSeferFiyati !== undefined && customerIcSeferFiyati !== null && customerIcSeferFiyati !== '') {
            icFiyat = parseFloat(customerIcSeferFiyati);
            console.log('💰 Müşteri özel iç sefer fiyatı kullanılıyor:', icFiyat, 'TL/sefer');
          } else {
            icFiyat = parseFloat(puantajData['İç Sefer Fiyatı'] || puantajData['icSeferFiyati'] || '0');
            console.log('🔧 Makine iç sefer fiyatı kullanılıyor:', icFiyat, 'TL/sefer');
          }
          
          if (customerDisSeferFiyati !== undefined && customerDisSeferFiyati !== null && customerDisSeferFiyati !== '') {
            disFiyat = parseFloat(customerDisSeferFiyati);
            console.log('💰 Müşteri özel dış sefer fiyatı kullanılıyor:', disFiyat, 'TL/sefer');
          } else {
            disFiyat = parseFloat(puantajData['Dış Sefer Fiyatı'] || puantajData['disSeferFiyati'] || '0');
            console.log('🔧 Makine dış sefer fiyatı kullanılıyor:', disFiyat, 'TL/sefer');
          }
          
          totalPrice = (icSeferSayisi * icFiyat) + (disSeferSayisi * disFiyat);
          
          console.log('🚛 Kamyon fiyat hesaplama:', {
            müşteri: customerName,
            makine: machineName,
            icSefer: icSeferSayisi,
            icFiyat: icFiyat,
            disSefer: disSeferSayisi,
            disFiyat: disFiyat,
            toplamFiyat: totalPrice
          });
        } else {
          // Normal makine puantajı - saatlik fiyatlandırma
          const specialHourlyRate = customerData['Özel Saatlik Fiyat'];
          
          if (specialHourlyRate !== undefined && specialHourlyRate !== null && specialHourlyRate !== '') {
            hourlyRate = parseFloat(specialHourlyRate);
            console.log('💰 Özel saatlik fiyat kullanılıyor:', hourlyRate, 'TL/saat');
          }
        }
      }

      // Normal makine puantajı için saatlik hesaplama
      if (!isKamyonPuantaji) {
        // Özel fiyat yoksa makine saatlik ücretini al
        if (hourlyRate === 0) {
          const machinesRef = collection(db, `users/${userEmail}/machines`);
          const machineQuery = query(machinesRef, where('MakineAdı', '==', machineName));
          const machineSnapshot = await getDocs(machineQuery);

          if (machineSnapshot.empty) {
            console.warn('Makine bulunamadı:', machineName);
            return null;
          }

          const machineDoc = machineSnapshot.docs[0];
          hourlyRate = parseFloat(machineDoc.data().BirimFiyat || '0');
          console.log('🔧 Makine saatlik fiyatı kullanılıyor:', hourlyRate, 'TL/saat');
        }

        // Çalışma süresini saate çevir - iOS HopsPlus ile AYNI MANTIK
        const totalMinutes = parseWorkingTime(workingTime);
        const totalHours = totalMinutes / 60;

        totalPrice = totalHours * hourlyRate;
        
        console.log('💰 Normal fiyat hesaplama:', {
          müşteri: customerName,
          makine: machineName,
          çalışmaSüresi: workingTime,
          toplamSaat: totalHours,
          saatlikÜcret: hourlyRate,
          toplamFiyat: totalPrice
        });
      }

      // Fiyatı formatlayıp döndür
      return totalPrice.toLocaleString('tr-TR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }) + ' TL';

    } catch (error) {
      console.error('Fiyat hesaplama hatası:', error);
      return null;
    }
  };

  // PDF indirme yardımcı fonksiyonu
  const triggerDownload = (blob, fileName) => {
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
  };

  // Hibrit PDF URL alma fonksiyonu - önce yeni sistem (pdfs/email/dosya), sonra eski sistem (pdfs/dosya)
  const getPdfDownloadUrl = useCallback(async (pdfName) => {
    const userEmail = auth.currentUser?.email;
    
    if (!userEmail) {
      throw new Error('Kullanıcı oturum bilgisi bulunamadı');
    }

    try {
      // Önce yeni sistem formatını dene: pdfs/{userEmail}/{pdfName}
      console.log(`🔍 Yeni formatta PDF aranıyor: pdfs/${userEmail}/${pdfName}`);
      const newFormatRef = ref(storage, `pdfs/${userEmail}/${pdfName}`);
      const url = await getDownloadURL(newFormatRef);
      console.log(`✅ PDF yeni formatta bulundu: pdfs/${userEmail}/${pdfName}`);
      return url;
    } catch (newFormatError) {
      console.log(`❌ Yeni formatta bulunamadı: ${newFormatError.message}`);
      
      try {
        // Yeni formatta bulunamazsa eski formatı dene: pdfs/{pdfName}
        console.log(`🔍 Eski formatta PDF aranıyor: pdfs/${pdfName}`);
        const oldFormatRef = ref(storage, `pdfs/${pdfName}`);
        const url = await getDownloadURL(oldFormatRef);
        console.log(`✅ PDF eski formatta bulundu: pdfs/${pdfName}`);
        return url;
      } catch (oldFormatError) {
        console.log(`❌ Eski formatta da bulunamadı: ${oldFormatError.message}`);
        throw new Error(`PDF dosyası bulunamadı: ${pdfName}`);
      }
    }
  }, []);

  // PDF önizleme için popup açma fonksiyonu - Hibrit sistem ile güncellendi
  const handlePdfPreview = useCallback(async (pdfRef, pdfName) => {
    try {
      const url = await getPdfDownloadUrl(pdfName);
      setSelectedPdf({ url, name: pdfName });
    } catch (error) {
      console.error('PDF önizlenirken hata:', error);
      setError('PDF önizlenirken bir hata oluştu');
      setAlertOpen(true);
    }
  }, [getPdfDownloadUrl]);

  // PDF indirme fonksiyonu (ayrı) - Hibrit sistem ile güncellendi
  const handlePdfDownload = useCallback(async (pdfRef, pdfName) => {
    try {
      const url = await getPdfDownloadUrl(pdfName);
      const response = await fetch(url);
      const blob = await response.blob();
      triggerDownload(blob, pdfName);
    } catch (error) {
      console.error('PDF indirilemedi:', error);
      setError('PDF indirilirken bir hata oluştu');
      setAlertOpen(true);
    }
  }, [getPdfDownloadUrl]);

  const closePopup = useCallback(() => {
    setSelectedPdf(null);
  }, []);

  const handleCheckboxChange = useCallback((pdfName) => {
    setSelectedPdfs((prevSelected) =>
      prevSelected.includes(pdfName)
        ? prevSelected.filter((name) => name !== pdfName)
        : [...prevSelected, pdfName]
    );
  }, []);

  // PDF'leri birleştirme fonksiyonu
  const mergePDFs = async (pdfBlobs) => {
    const mergedPdf = await PDFDocument.create();
    
    for (const blob of pdfBlobs) {
      const arrayBuffer = await blob.arrayBuffer();
      const pdf = await PDFDocument.load(arrayBuffer);
      const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
      copiedPages.forEach((page) => mergedPdf.addPage(page));
    }
    
    const mergedPdfFile = await mergedPdf.save();
    return new Blob([mergedPdfFile], { type: 'application/pdf' });
  };

  // PDF'den ilk sayfayı JPEG olarak indir (5 ve altı tekli, 6 ve üzeri zip)
  const downloadSelectedPdfsAsJpeg = async () => {
    if (selectedPdfs.length === 0) return;
    try {
      setLoading(true);
      if (selectedPdfs.length <= 5) {
        // Tek tek indir - Hibrit sistem ile güncellendi
        for (const pdfName of selectedPdfs) {
          const url = await getPdfDownloadUrl(pdfName);
          const response = await fetch(url);
          const blob = await response.blob();
          const arrayBuffer = await blob.arrayBuffer();
          const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
          const page = await pdf.getPage(1);
          const viewport = page.getViewport({ scale: 2 });
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          await page.render({ canvasContext: context, viewport }).promise;
          await new Promise(resolve => {
            canvas.toBlob((jpegBlob) => {
              if (jpegBlob) {
                const jpegUrl = window.URL.createObjectURL(jpegBlob);
                const link = document.createElement('a');
                link.href = jpegUrl;
                link.download = pdfName.replace(/\.pdf$/i, '.jpg');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(jpegUrl);
              }
              resolve();
            }, 'image/jpeg', 0.95);
          });
          await new Promise(resolve => setTimeout(resolve, 800));
        }
        setSuccessMessage('PDF\'ler başarıyla JPEG olarak indirildi.');
        setAlertOpen(true);
      } else {
        // ZIP olarak indir - Hibrit sistem ile güncellendi
        const zip = new JSZip();
        for (const pdfName of selectedPdfs) {
          const url = await getPdfDownloadUrl(pdfName);
          const response = await fetch(url);
          const blob = await response.blob();
          const arrayBuffer = await blob.arrayBuffer();
          const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
          const page = await pdf.getPage(1);
          const viewport = page.getViewport({ scale: 2 });
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          await page.render({ canvasContext: context, viewport }).promise;
          const jpegBlob = await new Promise(resolve => {
            canvas.toBlob((b) => resolve(b), 'image/jpeg', 0.95);
          });
          if (jpegBlob) {
            const arrayBuffer = await jpegBlob.arrayBuffer();
            zip.file(pdfName.replace(/\.pdf$/i, '.jpg'), arrayBuffer);
          }
        }
        const zipBlob = await zip.generateAsync({ type: 'blob' });
        const zipUrl = window.URL.createObjectURL(zipBlob);
        const link = document.createElement('a');
        link.href = zipUrl;
        link.download = 'puantaj_jpegler.zip';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(zipUrl);
        setSuccessMessage('PDF\'ler JPEG olarak zip dosyası halinde indirildi.');
        setAlertOpen(true);
      }
    } catch (error) {
      console.error('PDF to JPEG indirme hatası:', error);
      setError('PDF\'ler JPEG olarak indirilirken bir hata oluştu');
      setAlertOpen(true);
    } finally {
      setLoading(false);
      setIsDownloadModalOpen(false);
    }
  };

  // İndirme seçenekleri modalı
  const DownloadOptionsModal = () => (
    <div className="modal download-options-modal" onClick={() => setIsDownloadModalOpen(false)}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3>PDF İndirme Seçenekleri</h3>
        <p className="modal-description">
          Seçili {selectedPdfs.length} PDF dosyası için indirme yöntemini seçin:
        </p>
        <div className="download-options">
          <button 
            onClick={downloadSelectedPdfs} 
            disabled={loading}
            className="download-option-button individual"
          >
            <div className="button-icon">📄</div>
            <div className="button-content">
              <span className="button-title">Tek Tek İndir</span>
              <span className="button-description">Her PDF'i ayrı dosya olarak indir</span>
            </div>
            {loading && <span className="loading-spinner"></span>}
          </button>
          <button 
            onClick={handleDownloadAsMergedPDF} 
            disabled={loading}
            className="download-option-button merged"
          >
            <div className="button-icon">📑</div>
            <div className="button-content">
              <span className="button-title">Birleştirip İndir</span>
              <span className="button-description">Tüm PDF'leri tek dosyada birleştir</span>
            </div>
            {loading && <span className="loading-spinner"></span>}
          </button>
          <button
            onClick={downloadSelectedPdfsAsJpeg}
            disabled={loading}
            className="download-option-button jpeg"
          >
            <div className="button-icon">🖼️</div>
            <div className="button-content">
              <span className="button-title">JPEG olarak Tekli İndir</span>
              <span className="button-description">Her PDF'in ilk sayfasını JPEG olarak indir</span>
            </div>
            {loading && <span className="loading-spinner"></span>}
          </button>
        </div>
        <button onClick={() => setIsDownloadModalOpen(false)} className="close-button">
          Kapat
        </button>
      </div>
    </div>
  );



  const handleDownloadAsMergedPDF = async () => {
    if (selectedPdfs.length === 0) return;

    try {
      setLoading(true);
      
      // Seçili PDF'leri tarih bilgileriyle birlikte al ve sırala
      const pdfsWithDates = selectedPdfs.map(pdfName => {
        // allData içinde pdfName ile eşleşen veriyi bul
        const matchingData = allData.find(item => item.pdfName === pdfName);
        
        console.log('🔍 PDF eşleştirme:', {
          pdfName,
          found: !!matchingData,
          tarih: matchingData?.Tarih,
          allDataSample: allData.slice(0, 3).map(d => ({ pdfName: d.pdfName, Tarih: d.Tarih }))
        });
        
        return {
          pdfName,
          date: matchingData?.Tarih || '',
          data: matchingData
        };
      });

      // Tarihe göre sırala (en eski tarih önce - ilk sayfa, en yeni tarih sona - son sayfa)
      pdfsWithDates.sort((a, b) => {
        const dateA = parseDate(a.date);
        const dateB = parseDate(b.date);
        
        // Geçersiz tarihleri sona at
        if (!a.date && !b.date) return 0;
        if (!a.date) return 1;
        if (!b.date) return -1;
        
        return dateA.getTime() - dateB.getTime(); // En eski tarih önce (ascending)
      });

      console.log('📅 PDF\'ler tarih sırasına göre sıralandı (en eski tarih ilk sayfa, en yeni son sayfa):', 
        pdfsWithDates.map((pdf, index) => ({
          sira: index + 1,
          pdfName: pdf.pdfName,
          tarih: pdf.date,
          parsedDate: formatTrDateOnly(pdf.date)
        }))
      );

      // Sıralanmış PDF'leri SIRALI olarak indir (sırayı korumak için)
      const pdfBlobs = [];
      for (const pdfItem of pdfsWithDates) {
        const url = await getPdfDownloadUrl(pdfItem.pdfName);
        const response = await fetch(url);
        const blob = await response.blob();
        pdfBlobs.push(blob);
        console.log(`📥 İndirildi: ${pdfItem.pdfName} (Tarih: ${pdfItem.date})`);
      }

      const mergedPdfBlob = await mergePDFs(pdfBlobs);
      const timestamp = toIsoUtcString(new Date()).slice(0, 10);
      saveAs(mergedPdfBlob, `birlesik_puantajlar_${timestamp}.pdf`);

      setSuccessMessage(`PDF'ler tarih sırasına göre birleştirildi (${pdfsWithDates.length} adet - en eski tarih ilk sayfa).`);
      setAlertOpen(true);
    } catch (error) {
      console.error('PDF birleştirme hatası:', error);
      setError('PDF\'ler birleştirilirken bir hata oluştu');
      setAlertOpen(true);
    } finally {
      setLoading(false);
      setIsDownloadModalOpen(false);
    }
  };

  const handleSelectAll = useCallback(() => {
    const allPdfNames = filteredData.map((item) => item.pdfName);
    setSelectedPdfs(allPdfNames);
  }, [filteredData]);

  const handleDeselectAll = useCallback(() => {
    setSelectedPdfs([]);
  }, []);

  // Seçili PDF'leri tek tek indirme
  const downloadSelectedPdfs = async () => {
    if (selectedPdfs.length === 0) return;
    try {
      setLoading(true);
      
      for (const pdfName of selectedPdfs) {
        const url = await getPdfDownloadUrl(pdfName);
        
        // Fetch ile blob olarak al ve indir
        const response = await fetch(url);
        const blob = await response.blob();
        
        // Blob URL oluştur ve indir
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = pdfName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Blob URL'yi temizle
        window.URL.revokeObjectURL(blobUrl);
        
        // Her indirme arasında kısa bir bekleme
        await new Promise(resolve => setTimeout(resolve, 800));
      }
      
      setSuccessMessage('PDF\'ler başarıyla indirildi.');
      setAlertOpen(true);
    } catch (error) {
      console.error('PDF indirme hatası:', error);
      setError('PDF\'ler indirilirken bir hata oluştu');
      setAlertOpen(true);
    } finally {
      setLoading(false);
      setIsDownloadModalOpen(false);
    }
  };

  const formatTime = useCallback((timeString) => {
    if (!timeString || timeString === '""') return null;
    const [hours, minutes] = timeString.replace(/"/g, '').split(':');
    if (!hours || !minutes) return null;
    return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
  }, []);

  const calculateDuration = useCallback((start, end) => {
    if (!start || !end) return 0;
    const [startHours, startMinutes] = start.split(':').map(Number);
    const [endHours, endMinutes] = end.split(':').map(Number);
    let duration = endHours * 60 + endMinutes - (startHours * 60 + startMinutes);
    if (duration < 0) {
      duration += 24 * 60;
    }
    return duration;
  }, []);

  const formatDuration = useCallback((minutes) => {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    // Gerçek saat sistemi formatı (HH:MM)
    return `${hours.toString().padStart(2, '0')}:${remainingMinutes.toString().padStart(2, '0')}`;
  }, []);

  const calculateTotalWorkDuration = useCallback((item) => {
    const start1 = formatTime(item['1. Başlangıç Saati']);
    const end1 = formatTime(item['1. Bitiş Saati']);
    const start2 = formatTime(item['2. Başlangıç Saati']);
    const end2 = formatTime(item['2. Bitiş Saati']);

    const duration1 = calculateDuration(start1, end1);
    const duration2 = calculateDuration(start2, end2);

    const totalDuration = duration1 + duration2;

    if (totalDuration === 0) {
      return '-';
    }

    // Gerçek saat sistemi formatı (HH:MM)
    const hours = Math.floor(totalDuration / 60);
    const minutes = totalDuration % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }, [formatTime, calculateDuration]);

  const renderWorkHours = useCallback((item) => {
    const start1 = formatTime(item['1. Başlangıç Saati']);
    const end1 = formatTime(item['1. Bitiş Saati']);
    const start2 = formatTime(item['2. Başlangıç Saati']);
    const end2 = formatTime(item['2. Bitiş Saati']);

    if (start1 && end1) {
      if (start2 && end2) {
        return (
          <>
            {start1} || {end1}
            <br />
            {start2} || {end2}
          </>
        );
      } else {
        return (
          <>
            {start1} || {end1}
          </>
        );
      }
    } else {
      return '-';
    }
  }, [formatTime]);

  const renderWorkDetails = useCallback((item) => {
    return (
      <div className="work-details">
        <strong>Çalışma Saatleri:</strong> {renderWorkHours(item)}
        <br />
        <strong>Toplam Süre:</strong> {calculateTotalWorkDuration(item)}
        <br />
        <strong>Yetkili:</strong> {item['Yetkili Adı'] || '-'}
        <br />
        <strong>Detay:</strong> {item['Çalışma Detayı'] || '-'}
      </div>
    );
  }, [renderWorkHours, calculateTotalWorkDuration]);

  const closeHakedisPopup = useCallback(() => {
    setIsHakedisPopupOpen(false);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        closeHakedisPopup();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [closeHakedisPopup]);

  const handleCustomerChange = useCallback((selectedOptions) => {
    setSelectedCustomers(selectedOptions || []);
  }, []);

  const handleMachineChange = useCallback((selectedOptions) => {
    setSelectedMachines(selectedOptions || []);
  }, []);

  const handleOperatorChange = useCallback((selectedOptions) => {
    setSelectedOperators(selectedOptions || []);
  }, []);

  // Yeni fonksiyonlar
  const checkAndCreateCustomer = useCallback(async (customerName, cariCode) => {
    if (!auth.currentUser?.email) {
      console.error('Kullanıcı oturumu bulunamadı');
      return;
    }
    
    const db = getFirestore();
    const customerRef = collection(db, COLLECTION_PATHS.USER_CUSTOMERS(auth.currentUser.email));
    const customerQuery = query(customerRef, 
      where('Müşteri Adı', '==', customerName)
    );
    
    try {
      const customerSnapshot = await getDocs(customerQuery);
      
      if (customerSnapshot.empty) {
        // Yeni müşteri oluştur
        const newCustomerData = {
          'Müşteri Adı': customerName,
          'cariCode': cariCode || '',
          'Onay': 'Onaylandı', // String olarak direkt değeri veriyoruz
          'createdAt': toIsoUtcString(new Date()),
          'createdBy': auth.currentUser.email,
          'updatedAt': toIsoUtcString(new Date()),
          'isActive': true
        };

        console.log('Eklenecek yeni müşteri verisi:', newCustomerData); // Debug için

        const docRef = await addDoc(customerRef, newCustomerData);
        console.log('Yeni müşteri eklendi:', docRef.id, newCustomerData);
      } else {
        console.log('Bu müşteri zaten mevcut:', customerName); // Debug için
      }
    } catch (error) {
      console.error('Müşteri ekleme hatası:', error);
    }
  }, []);

  // Puantaj değişikliklerini izleyen listener
  useEffect(() => {
    if (!auth.currentUser?.email) return;

    const db = getFirestore();
    const puantajlarRef = collection(db, COLLECTIONS.PUANTAJLAR);
    
    const unsubscribe = onSnapshot(puantajlarRef, async (snapshot) => {
      snapshot.docChanges().forEach(async (change) => {
        if (change.type === 'added' || change.type === 'modified') {
          const puantajData = change.doc.data();
          const customerName = puantajData['Müşteri Adı']?.trim() || 
                             puantajData['MusteriAdi']?.trim() || 
                             puantajData['musteriAdi']?.trim();
                             
          const cariCode = puantajData['Cari Kodu']?.trim() || 
                          puantajData['CariKodu']?.trim() || 
                          puantajData['cariKodu']?.trim() || 
                          puantajData['cariCode']?.trim();
                          
          if (customerName) {
            console.log('Yeni puantaj eklendi/güncellendi:', customerName); // Debug için
            await checkAndCreateCustomer(customerName, cariCode);
          }
        }
      });
    });

    return () => unsubscribe();
  }, [checkAndCreateCustomer]);

  // Müşteri değişikliklerini izleyen listener
  // Component unmount edildiğinde timeout'u temizle
  useEffect(() => {
    return () => {
      if (loadingTimeoutRef.current) {
        clearTimeout(loadingTimeoutRef.current);
        console.log('🧹 Component unmount - loading timeout temizlendi');
      }
    };
  }, []); // Dependency array'den loadingTimeoutRef'i kaldır

  useEffect(() => {
    if (!auth.currentUser?.email) return;

    const db = getFirestore();
    const customerListRef = collection(db, COLLECTION_PATHS.USER_CUSTOMERS(auth.currentUser.email));
    
    const unsubscribe = onSnapshot(customerListRef, (snapshot) => {
      snapshot.docChanges().forEach((change) => {
        if (change.type === 'modified') {
          const newData = change.doc.data();
          const oldData = change.doc.data();
          
          // Müşteri adı değişmişse, puantajları güncelle
          if (oldData['Müşteri Adı'] !== newData['Müşteri Adı']) {
            // Puantajları yeniden yükle
            const puantajlarRef = collection(db, COLLECTIONS.PUANTAJLAR);
            const puantajQuery = query(
              puantajlarRef,
              where('owner', '==', auth.currentUser.email)
            );
            
            getDocs(puantajQuery).then((puantajSnapshot) => {
              const updatedPuantajlar = puantajSnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
              }));
              
              setAllData(prevData => {
                const newData = [...prevData];
                updatedPuantajlar.forEach(puantaj => {
                  const index = newData.findIndex(item => item.id === puantaj.id);
                  if (index !== -1) {
                    newData[index] = puantaj;
                  }
                });
                return newData;
              });
              
              setFilteredData(prevData => {
                const newData = [...prevData];
                updatedPuantajlar.forEach(puantaj => {
                  const index = newData.findIndex(item => item.id === puantaj.id);
                  if (index !== -1) {
                    newData[index] = puantaj;
                  }
                });
                return newData;
              });
            });
          }
        }
      });
    });

    return () => unsubscribe();
  }, []);

  const handleEditClick = (puantaj) => {
    // Çoklu tık engellemesi
    if (isEditModalOpen || isPdfRegeneratingLoading) {
      console.warn('⚠️ Edit modal zaten açık veya PDF oluşturuluyor, işlem engellendi');
      return;
    }
    
    console.log('🔧 handleEditClick çağrıldı:', puantaj);
    setSelectedPuantaj(puantaj);
    
    // Tarih formatını dönüştüren yardımcı fonksiyon (DD.MM.YYYY -> YYYY-MM-DD)
    const formatDateForInput = (dateStr) => {
      if (!dateStr) return '';
      const d = parseFlexible(dateStr);
      if (!d) return dateStr;
      return toIsoUtcString(d).slice(0, 10);
    };
    
    // Form verilerini state'te sakla
    const formDataObj = {};
    Object.keys(formRefs.current).forEach(key => {
      let value = puantaj[key] || '';
      
      // Saat alanları için özel formatla
      if (key.includes('Saati')) {
        value = formatTimeForInput(value);
      }
      
      // Tarih alanı için özel formatla
      if (key === 'Tarih') {
        value = formatDateForInput(value);
      }
      
      // Yetkili Adı için "Erer" default değerini temizle - kullanıcı ne yazdıysa o çıksın, boş bıraktıysa boş kalsın
      if (key === 'Yetkili Adı' && value.trim().toLowerCase() === 'erer') {
        value = '';
      }
      
      // Çalışma Detayı alanı için alternatif field adlarını kontrol et
      if (key === 'Çalışma Detayı' && (!value || value === '')) {
        // Tüm puantaj objesinin key'lerini kontrol et
        console.log('🔍 Puantaj objesinin tüm key\'leri:', Object.keys(puantaj));
        console.log('🔍 Çalışma detayı ile ilgili key\'ler:', 
          Object.keys(puantaj).filter(k => 
            k.toLowerCase().includes('çalışma') || 
            k.toLowerCase().includes('calisma') || 
            k.toLowerCase().includes('detay') || 
            k.toLowerCase().includes('aciklama') || 
            k.toLowerCase().includes('description') || 
            k.toLowerCase().includes('work')
          )
        );
        
        value = puantaj['Çalışma Detayı']?.trim() || 
               puantaj['CalismaDetayi']?.trim() || 
               puantaj['calismaDetayi']?.trim() || 
               puantaj['description']?.trim() || 
               puantaj['aciklama']?.trim() || 
               puantaj['detay']?.trim() || 
               puantaj['workDetail']?.trim() || 
               puantaj['work_detail']?.trim() || 
               puantaj['Detay']?.trim() || 
               puantaj['Açıklama']?.trim() || 
               puantaj['workDescription']?.trim() || 
               puantaj['work_description']?.trim() || 
               puantaj['calismaBilgisi']?.trim() || 
               puantaj['calisma_bilgisi']?.trim() || 
               puantaj['çalışmaBilgisi']?.trim() || 
               puantaj['çalışma_bilgisi']?.trim() || '';
        
        console.log('🔍 Çalışma detayı değeri bulundu:', value);
      }
      
      formDataObj[key] = value;
      console.log(`📝 Form alanı hazırlandı: ${key} = "${value}"`);
    });
    
    console.log('📋 Hazırlanan form verileri:', formDataObj);
    setEditFormData(formDataObj);
    setIsEditModalOpen(true);
  };

  // Çalışma saatlerini hesaplayan yardımcı fonksiyon (dakika cinsinden döndürür)
  const calculateWorkingHours = useCallback((puantajData) => {
    let totalMinutes = 0;
    
    // 1. vardiya
    if (puantajData['1. Başlangıç Saati'] && puantajData['1. Bitiş Saati']) {
      const start1 = formatTime(puantajData['1. Başlangıç Saati']);
      const end1 = formatTime(puantajData['1. Bitiş Saati']);
      if (start1 && end1) {
        totalMinutes += calculateDuration(start1, end1);
      }
    }
    
    // 2. vardiya
    if (puantajData['2. Başlangıç Saati'] && puantajData['2. Bitiş Saati']) {
      const start2 = formatTime(puantajData['2. Başlangıç Saati']);
      const end2 = formatTime(puantajData['2. Bitiş Saati']);
      if (start2 && end2) {
        totalMinutes += calculateDuration(start2, end2);
      }
    }
    
    // Sonucu saat cinsinden döndür (ondalık olarak - borç hesaplamaları için)
    return totalMinutes / 60;
  }, [formatTime, calculateDuration]);

  // HopsPlus mantığına uygun müşteri değişikliği borç transferi
  const handleCustomerChangeDebtTransfer = async (oldCustomerName, newCustomerName, machineName, totalHours, puantajId, puantajDate = null) => {
    if (!oldCustomerName || !newCustomerName || oldCustomerName === newCustomerName) {
      console.log('Müşteri değişikliği yok, borç transferi gerekmiyor');
      return;
    }

    console.log('🔄 HopsPlus mantığı - Müşteri değişikliği borç transferi başlıyor:', {
      eskiMüşteri: oldCustomerName,
      yeniMüşteri: newCustomerName,
      makine: machineName,
      toplamSaat: totalHours,
      puantajId: puantajId
    });

    try {
      const db = getFirestore();
      const userEmail = auth.currentUser.email;
      
      // Yeni müşteriyi bul (özel saatlik fiyat için)
      const customerRef = collection(db, `users/${userEmail}/customerList`);
      const customerQuery = query(customerRef, where('Müşteri Adı', '==', newCustomerName));
      const customerSnapshot = await getDocs(customerQuery);
      
      let hourlyRate = 0;
      let customerIcSeferFiyati = null;
      let customerDisSeferFiyati = null;
      
      if (!customerSnapshot.empty) {
        const customerDoc = customerSnapshot.docs[0];
        const customerData = customerDoc.data();
        const specialHourlyRate = customerData['Özel Saatlik Fiyat'];
        
        // Müşteri özel sefer fiyatlarını al (kamyon puantajları için)
        customerIcSeferFiyati = customerData['Özel İç Sefer Fiyatı'];
        customerDisSeferFiyati = customerData['Özel Dış Sefer Fiyatı'];
        
        if (specialHourlyRate !== undefined && specialHourlyRate !== null && specialHourlyRate !== '') {
          hourlyRate = parseFloat(specialHourlyRate);
          console.log('💰 Müşteri değişikliği - Özel saatlik fiyat kullanılıyor:', hourlyRate, 'TL/saat');
        }
        
        console.log('💰 Müşteri değişikliği - Özel sefer fiyatları:', {
          icSeferFiyati: customerIcSeferFiyati,
          disSeferFiyati: customerDisSeferFiyati
        });
      }
      
      // Özel fiyat yoksa makine saatlik ücretini al
      if (hourlyRate === 0) {
        const machinesRef = collection(db, `users/${userEmail}/machines`);
        const machineQuery = query(machinesRef, where('MakineAdı', '==', machineName));
        const machineSnapshot = await getDocs(machineQuery);
        
        if (machineSnapshot.empty) {
          console.warn('Makine bulunamadı:', machineName);
          return;
        }
        
        const machineDoc = machineSnapshot.docs[0];
        hourlyRate = parseFloat(machineDoc.data().BirimFiyat || '0');
        console.log('🔧 Müşteri değişikliği - Makine saatlik fiyatı kullanılıyor:', hourlyRate, 'TL/saat');
      }
      
      const totalDebtAmount = totalHours * hourlyRate;
      
      if (totalDebtAmount <= 0) {
        console.log('Borç tutarı 0 veya negatif, transfer gerekmiyor');
        return;
      }

      // Puantaj kodunu kısalt (sadece son 8 karakter)
      const shortPuantajCode = puantajId ? puantajId.slice(-8) : 'BILINMEYEN';
      
      // Tarih - eğer puantaj tarihi verilmişse onu kullan, yoksa şimdiki zamanı kullan
      const currentTimeString = puantajDate || toIsoUtcString(new Date());

      // Firebase kuralına uygun: Önce customer ID'leri bul
      const oldCustomerRef = collection(db, `users/${userEmail}/customerList`);
      const oldCustomerQuery = query(oldCustomerRef, where('Müşteri Adı', '==', oldCustomerName));
      const oldCustomerSnapshot = await getDocs(oldCustomerQuery);
      
      if (oldCustomerSnapshot.empty) {
        console.warn('❌ Eski müşteri bulunamadı:', oldCustomerName);
        console.log('🔍 Müşteri arama detayları:', {
          arananMüşteri: oldCustomerName,
          userEmail: userEmail,
          koleksiyon: `users/${userEmail}/customerList`
        });
        return;
      }
      
      const oldCustomerDoc = oldCustomerSnapshot.docs[0];
      const oldCustomerData = oldCustomerDoc.data();
      console.log('✅ Eski müşteri bulundu:', {
        müşteriId: oldCustomerDoc.id,
        müşteriAdı: oldCustomerData['Müşteri Adı'],
        onayDurumu: oldCustomerData['Onay'],
        cariCode: oldCustomerData['cariCode']
      });
      
      const newCustomerRef = collection(db, `users/${userEmail}/customerList`);
      const newCustomerQuery = query(newCustomerRef, where('Müşteri Adı', '==', newCustomerName));
      const newCustomerSnapshot = await getDocs(newCustomerQuery);
      
      if (newCustomerSnapshot.empty) {
        console.warn('❌ Yeni müşteri bulunamadı:', newCustomerName);
        return;
      }
      
      const newCustomerDoc = newCustomerSnapshot.docs[0];
      const newCustomerData = newCustomerDoc.data();
      console.log('✅ Yeni müşteri bulundu:', {
        müşteriId: newCustomerDoc.id,
        müşteriAdı: newCustomerData['Müşteri Adı'],
        onayDurumu: newCustomerData['Onay'],
        cariCode: newCustomerData['cariCode']
      });
      
      const oldCustomerId = oldCustomerSnapshot.docs[0].id;
      const newCustomerId = newCustomerSnapshot.docs[0].id;
      const oldDebtRef = doc(db, `users/${userEmail}/customerList/${oldCustomerId}/debt/current`);
      const newDebtRef = doc(db, `users/${userEmail}/customerList/${newCustomerId}/debt/current`);

      // HopsPlus mantığı: Transaction ile atomik işlem - TÜM OKUMALAR ÖNCE
      await runTransaction(db, async (transaction) => {
        // 1. TÜM READ İŞLEMLERİ ÖNCE (Firebase kuralı)
        console.log('📖 Tüm veri okumaları yapılıyor...');
        const oldDebtDoc = await transaction.get(oldDebtRef);
        const newDebtDoc = await transaction.get(newDebtRef);
        
        console.log('💰 Cari hesap durumları:', {
          eskiMüşteriCariMevcut: oldDebtDoc.exists(),
          yeniMüşteriCariMevcut: newDebtDoc.exists(),
          eskiMüşteriCariYolu: oldDebtRef.path,
          yeniMüşteriCariYolu: newDebtRef.path
        });
        
        // 2. VERİ İŞLEME (Read işlemlerinden sonra)
        console.log('🔍 Eski müşterde puantaj işlemi aranıyor:', oldCustomerName);
        
        let oldCurrentHistory = oldDebtDoc.exists() ? (oldDebtDoc.data().history || []) : [];
        
        if (oldDebtDoc.exists()) {
          const oldDebtData = oldDebtDoc.data();
          console.log('📊 Eski müşteri cari hesap detayları:', {
            totalAmount: oldDebtData.amount,
            historyLength: oldCurrentHistory.length,
            historyTypes: oldCurrentHistory.map(h => h.type),
            historyDescriptions: oldCurrentHistory.slice(0, 3).map(h => h.description)
          });
        } else {
          console.warn('⚠️ Eski müşterinin cari hesabı hiç oluşturulmamış!');
        }
        
        // Puantaj işlemini bul ve SİL - güçlü arama fonksiyonu kullan
        console.log('🔍 Puantaj işlemi arama kriterleri:', {
          shortPuantajCode: shortPuantajCode,
          fullPuantajId: puantajId,
          historyLength: oldCurrentHistory.length,
          puantajCodes: oldCurrentHistory.map(h => h.puantajCode).filter(Boolean),
          allDescriptions: oldCurrentHistory.map(h => h.description)
        });
        
        const oldPuantajResult = findDebtHistoryEntryByPuantajCode(oldCurrentHistory, shortPuantajCode, null, puantajId);
        
        if (oldPuantajResult.found) {
          // Puantaj işlemini TAMAMEN sil
          oldCurrentHistory.splice(oldPuantajResult.index, 1);
          console.log('✅ Eski müşteriden puantaj işlemi silindi:', {
            index: oldPuantajResult.index,
            silenenIslem: oldPuantajResult.entry.description,
            eskiMüşteriOnayDurumu: oldCustomerData['Onay']
          });
          
          // Transfer bilgisi ekle (sadece görünüm için, isInfoOnly=true)
          const transferInfoEntry = {
            id: `transfer_out_${Date.now()}_${Math.random().toString(36).substr(2, 8)}`,
            amount: 0, // Sıfır amount
            date: currentTimeString,
            description: `Puantaj düzenleme - ${newCustomerName} müşterisine aktarıldı`,
            isInfoOnly: true, // Hesaplamaya katılmaz
            transferFrom: oldCustomerName,
            transferTo: newCustomerName,
            type: "transfer_out"
          };
          
          oldCurrentHistory.push(transferInfoEntry);
        } else {
          console.error('❌❌❌ KRİTİK HATA - Eski müşteriden silinecek puantaj işlemi bulunamadı!', {
            puantajCode: shortPuantajCode,
            puantajId: puantajId,
            oldCustomerName: oldCustomerName,
            eskiMüşteriOnayDurumu: oldCustomerData['Onay'],
            historyLength: oldCurrentHistory.length,
            historyEntries: oldCurrentHistory.map((h, index) => ({
              index: index,
              description: h.description,
              puantajCode: h.puantajCode,
              type: h.type,
              amount: h.amount
            }))
          });
          
          // ONAY BEKLİYOR MÜŞTERİLERİ İÇİN ÖZEL DURUM - YİNE DE SİLMEYE ÇALIŞ
          console.log('🚨 Onay bekliyor müşterisi için alternatif silme denemesi...');
        }
        
        // Yeni toplam amount'ı hesapla
        const newOldAmount = oldCurrentHistory
          .filter(h => !h.isInfoOnly)
          .reduce((total, h) => total + (parseFloat(h.amount) || 0), 0);
        
        // Eski müşteriyi güncelle
        transaction.set(oldDebtRef, {
          amount: newOldAmount,
          history: oldCurrentHistory,
          lastUpdated: currentTimeString,
          customerName: oldCustomerName
        });

        // 3. YENİ MÜŞTERİ: Puantaj işlemi ekle
        console.log('➕ Yeni müşteriye puantaj işlemi ekleniyor:', newCustomerName);
        
        let newCurrentHistory = newDebtDoc.exists() ? (newDebtDoc.data().history || []) : [];
        
        // Yeni puantaj işlemi ekle
        const newPuantajEntry = {
          id: `puantaj_${Date.now()}_${Math.random().toString(36).substr(2, 8)}`,
          amount: totalDebtAmount, // Pozitif amount
          date: currentTimeString,
                      description: `Puantaj: ${shortPuantajCode} - ${machineName} (${Math.floor(totalHours)}:${Math.floor((totalHours % 1) * 60).toString().padStart(2, '0')} saat)`,
          type: "increase",
          paymentMethod: "Puantaj",
          machineHours: totalHours,
          hourlyRate: hourlyRate,
          machineName: machineName,
          puantajCode: shortPuantajCode,
          originalPuantajId: puantajId,
          isEdited: false,
          editCount: 0,
          originalAmount: totalDebtAmount,
          originalDate: currentTimeString,
                      originalDescription: `Puantaj: ${shortPuantajCode} - ${machineName} (${Math.floor(totalHours)}:${Math.floor((totalHours % 1) * 60).toString().padStart(2, '0')} saat)`,
          transferredFrom: oldCustomerName,
          transferredAt: currentTimeString
        };
        
        newCurrentHistory.push(newPuantajEntry);
        
        // Yeni toplam amount'ı hesapla
        const newNewAmount = newCurrentHistory
          .filter(h => !h.isInfoOnly)
          .reduce((total, h) => total + (parseFloat(h.amount) || 0), 0);
        
        // Yeni müşteriyi güncelle
        transaction.set(newDebtRef, {
          amount: newNewAmount,
          history: newCurrentHistory,
          lastUpdated: currentTimeString,
          customerName: newCustomerName
        });

        console.log('✅ HopsPlus mantığı - Borç transferi tamamlandı:', {
          eskiMüşteri: `${oldCustomerName} (Yeni toplam: ${newOldAmount} TL)`,
          yeniMüşteri: `${newCustomerName} (Yeni toplam: ${newNewAmount} TL)`,
          transferEdilen: `${totalDebtAmount} TL`
        });
      });
      
    } catch (error) {
      console.error('❌ HopsPlus mantığı - Borç transferi hatası:', error);
      throw error;
    }
  };

  // Puantaj ID'sine göre cari geçmişinde ilgili işlemi bulma fonksiyonu
  const findDebtHistoryEntryByPuantajCode = (history, puantajCode, fullPuantajId = null, puantajId = null) => {
    if (!history || !puantajCode) return { found: false, index: -1, entry: null };
    
    // Puantaj kodu ile eşleşen işlemi bul
    const index = history.findIndex(entry => {
      // 1. Direkt puantajCode eşleşmesi
      if (entry.puantajCode === puantajCode) {
        return true;
      }
      
      // 2. Hops uygulamasından gelen puantajId eşleşmesi
      if (entry.puantajId === puantajCode) {
        return true;
      }
      
      // 3. Tam puantaj ID'si ile eşleşme (kısaltılmış değil)
      if (entry.puantajId && entry.puantajId.endsWith(puantajCode)) {
        return true;
      }
      
      // 4. Tam puantaj ID'si ile eşleşme (tam ID)
      if (entry.puantajId === puantajId) {
        return true;
      }
      
      // 3. Description içinde puantaj kodu geçiyor mu?
      if (entry.description && entry.description.includes(puantajCode)) {
        return true;
      }
      
      // 4. Orijinal puantaj işlemleri için - description'da "Puantaj:" ile başlayan ve puantaj kodu içeren
      if (entry.description && entry.description.includes('Puantaj:') && entry.description.includes(puantajCode)) {
        return true;
      }
      
      // 5. Orijinal puantaj işlemleri için - description'da puantaj numarası geçiyor mu?
      if (entry.description && entry.description.match(/Puantaj:\s*(\d+)/)) {
        const match = entry.description.match(/Puantaj:\s*(\d+)/);
        if (match && match[1] && puantajCode.includes(match[1])) {
          return true;
        }
      }
      
      // 6. Orijinal puantaj işlemleri için - description'da makine adı ve saat bilgisi var mı?
      if (entry.description && entry.description.includes('saat') && entry.description.includes('dakika')) {
        // Bu orijinal puantaj işlemi olabilir, puantaj kodu ile eşleşme kontrol et
        if (entry.description.includes(puantajCode)) {
          return true;
        }
      }
      
      return false;
    });
    
    if (index !== -1) {
      console.log('🔍 Mevcut puantaj işlemi bulundu:', {
        index: index,
        description: history[index].description,
        puantajCode: puantajCode,
        entry: history[index]
      });
      
      return {
        found: true,
        index: index,
        entry: history[index]
      };
    }
    
    console.log('❌ Mevcut puantaj işlemi bulunamadı:', {
      puantajCode: puantajCode,
      fullPuantajId: fullPuantajId,
      historyLength: history.length,
      historyDescriptions: history.map(h => h.description).slice(0, 5), // İlk 5 açıklamayı göster
      historyPuantajIds: history.map(h => h.puantajId).slice(0, 5), // İlk 5 puantajId'yi göster
      historyPuantajCodes: history.map(h => h.puantajCode).slice(0, 5) // İlk 5 puantajCode'u göster
    });
    
    return { found: false, index: -1, entry: null };
  };

  // Cari geçmişindeki işlem tarihini güncelleyen fonksiyon
  const updateDebtHistoryEntryDate = async (customerName, puantajCode, newDate) => {
    if (!customerName || !puantajCode || !newDate) return false;

    try {
      const db = getFirestore();
      const userEmail = auth.currentUser.email;
      
      // Müşteriyi bul
      const customerRef = collection(db, `users/${userEmail}/customerList`);
      const customerQuery = query(customerRef, where('Müşteri Adı', '==', customerName));
      const customerSnapshot = await getDocs(customerQuery);
      
      if (customerSnapshot.empty) {
        console.warn('Müşteri bulunamadı:', customerName);
        return false;
      }
      
      const customerDoc = customerSnapshot.docs[0];
      const customerId = customerDoc.id;
      
      // Müşteri borç referansı
      const debtRef = doc(db, `users/${userEmail}/customerList/${customerId}/debt/current`);
      
      // Transaction kullanarak atomik güncelleme
      let updateResult = false;
      
      await runTransaction(db, async (transaction) => {
        const debtDoc = await transaction.get(debtRef);
        
        if (!debtDoc.exists()) {
          console.warn('Borç belgesi bulunamadı:', customerName);
          return;
        }
        
        const debtData = debtDoc.data();
        const history = debtData.history || [];
        
        // Puantaj koduna göre işlemi bul
        const searchResult = findDebtHistoryEntryByPuantajCode(history, puantajCode, null, null);
        
        if (!searchResult.found) {
          console.warn('Puantaj koduna ait işlem bulunamadı:', puantajCode);
          return;
        }
        
        console.log('🔍 Cari geçmişinde güncellenecek işlem bulundu:', {
          index: searchResult.index,
          eskiTarih: searchResult.entry.date,
          yeniTarih: newDate,
          açıklama: searchResult.entry.description
        });
        
        // History'yi güncelle - sadece tarihi değiştir
        const updatedHistory = [...history];
        updatedHistory[searchResult.index] = {
          ...searchResult.entry,
          date: newDate
        };
        
        // Firebase'e kaydet
        transaction.update(debtRef, {
          history: updatedHistory,
          lastUpdated: toIsoUtcString(new Date())
        });
        
        updateResult = true;
        
        console.log('✅ Cari geçmişi tarihi güncellendi:', {
          müşteri: customerName,
          puantajKodu: puantajCode,
          eskiTarih: searchResult.entry.date,
          yeniTarih: newDate
        });
      });
      
      return updateResult;
      
    } catch (error) {
      console.error('Cari geçmişi tarih güncelleme hatası:', error);
      return false;
    }
  };

  // HopsPlus mantığına uygun puantaj düzenleme borç güncellemesi - AYNI SATIRDA güncelleme
  const updateCustomerDebt = async (customerName, machineName, hoursDifference, puantajId, newPuantajDate = null) => {
    if (!customerName || !machineName || Math.abs(hoursDifference) < 0.01) return;

    console.log('🔄 HopsPlus mantığı - Puantaj düzenleme borç güncellemesi:', {
      müşteri: customerName,
      makine: machineName,
      saatFarkı: hoursDifference,
      puantajId: puantajId
    });

    try {
      const db = getFirestore();
      const userEmail = auth.currentUser.email;
      
      // Müşteriyi bul (özel saatlik fiyat için)
      const customerRef = collection(db, `users/${userEmail}/customerList`);
      const customerQuery = query(customerRef, where('Müşteri Adı', '==', customerName));
      const customerSnapshot = await getDocs(customerQuery);
      
      if (customerSnapshot.empty) {
        console.warn('Müşteri bulunamadı:', customerName);
        return;
      }
      
      const customerDoc = customerSnapshot.docs[0];
      const customerData = customerDoc.data();
      const customerId = customerDoc.id;
      
      // Önce özel saatlik fiyatı kontrol et
      let hourlyRate = 0;
      const specialHourlyRate = customerData['Özel Saatlik Fiyat'];
      
      // Müşteri özel sefer fiyatları (kamyon puantajları için)
      const customerIcSeferFiyati = customerData['Özel İç Sefer Fiyatı'];
      const customerDisSeferFiyati = customerData['Özel Dış Sefer Fiyatı'];
      
      if (specialHourlyRate !== undefined && specialHourlyRate !== null && specialHourlyRate !== '') {
        hourlyRate = parseFloat(specialHourlyRate);
        console.log('💰 Cari kasa - Özel saatlik fiyat kullanılıyor:', hourlyRate, 'TL/saat');
      } else {
        // Özel fiyat yoksa makine saatlik ücretini al
        const machinesRef = collection(db, `users/${userEmail}/machines`);
        const machineQuery = query(machinesRef, where('MakineAdı', '==', machineName));
        const machineSnapshot = await getDocs(machineQuery);
        
        if (machineSnapshot.empty) {
          console.warn('Makine bulunamadı:', machineName);
          return;
        }
        
        const machineDoc = machineSnapshot.docs[0];
        hourlyRate = parseFloat(machineDoc.data().BirimFiyat || '0');
        console.log('🔧 Cari kasa - Makine saatlik fiyatı kullanılıyor:', hourlyRate, 'TL/saat');
      }
      const debtRef = doc(db, `users/${userEmail}/customerList/${customerId}/debt/current`);
      
      // Müşteri özel sefer fiyatlarını context'e ekle (kamyon puantajları için kullanılabilir)
      console.log('💰 Cari kasa - Müşteri özel sefer fiyatları:', {
        icSeferFiyati: customerIcSeferFiyati,
        disSeferFiyati: customerDisSeferFiyati
      });
      
      // Puantaj kodunu kısalt (sadece son 8 karakter)
      const shortPuantajCode = puantajId ? puantajId.slice(-8) : 'BILINMEYEN';
      const currentTimeString = newPuantajDate || toIsoUtcString(new Date());
      
      // Transaction kullanarak atomik güncelleme
      await runTransaction(db, async (transaction) => {
        const debtDoc = await transaction.get(debtRef);
        let currentHistory = debtDoc.exists() ? (debtDoc.data().history || []) : [];
        
        // HopsPlus mantığı: Mevcut puantaj işlemini bul ve AYNI SATIRDA güncelle
        const existingEntryResult = findDebtHistoryEntryByPuantajCode(currentHistory, shortPuantajCode, null, puantajId);
        
        if (existingEntryResult.found) {
          // AYNI SATIRDA güncelleme (HopsPlus mantığı)
          console.log('🔄 AYNI SATIRDA puantaj düzenleme:', shortPuantajCode);
          
          const existingEntry = existingEntryResult.entry;
          const existingIndex = existingEntryResult.index;
          
          // Eski saat ve tutarı al
          const oldMachineHours = existingEntry.machineHours || 0;
          const oldAmount = existingEntry.amount || 0;
          
          // Yeni saat ve tutarı hesapla
          const newMachineHours = Math.max(0, oldMachineHours + hoursDifference);
          const newAmount = newMachineHours * hourlyRate;
          
          // Düzenleme sayısını artır
          const editCount = (existingEntry.editCount || 0) + 1;
          
          // AYNI INDEX'te güncelle (yeni satır ekleme!)
          currentHistory[existingIndex] = {
            ...existingEntry,
            amount: newAmount, // YENİ TOPLAM tutar
            machineHours: newMachineHours, // YENİ TOPLAM saat
            date: currentTimeString,
            description: `Puantaj: ${shortPuantajCode} - ${machineName} (${Math.floor(newMachineHours)}:${Math.floor((newMachineHours % 1) * 60).toString().padStart(2, '0')} saat)`,
            hourlyRate: hourlyRate,
            isEdited: true,
            editCount: editCount,
            lastUpdatedAt: currentTimeString,
            lastUpdatedBy: userEmail,
            // Orijinal bilgileri koru
            originalAmount: existingEntry.originalAmount || oldAmount,
            originalDate: existingEntry.originalDate || existingEntry.date,
            originalDescription: existingEntry.originalDescription || existingEntry.description
          };
          
          console.log('✅ AYNI SATIRDA güncellendi:', {
            müşteri: customerName,
            puantajKodu: shortPuantajCode,
            eskiSaat: oldMachineHours,
            yeniSaat: newMachineHours,
            saatFarkı: hoursDifference,
            eskiTutar: oldAmount,
            yeniTutar: newAmount,
            düzenlemeNo: editCount
          });
          
        } else {
          // Mevcut puantaj bulunamadı - yeni işlem oluştur (istenmeyen durum!)
          console.warn('⚠️ Mevcut puantaj işlemi bulunamadı, yeni işlem oluşturuluyor:', shortPuantajCode);
          
          const newAmount = Math.abs(hoursDifference) * hourlyRate;
          const newHistoryEntry = {
            id: `puantaj_edit_${Date.now()}_${Math.random().toString(36).substr(2, 8)}`,
            amount: newAmount,
            date: currentTimeString,
            description: `${machineName} (${Math.floor(Math.abs(hoursDifference))}:${Math.floor((Math.abs(hoursDifference) % 1) * 60).toString().padStart(2, '0')} ${hoursDifference > 0 ? 'artış' : 'azalış'}) - Puantaj: ${shortPuantajCode} (Yeni)`,
            type: "increase",
            paymentMethod: "Puantaj Düzenleme",
            machineHours: Math.abs(hoursDifference),
            hourlyRate: hourlyRate,
            machineName: machineName,
            puantajCode: shortPuantajCode,
            originalPuantajId: puantajId,
            isEdited: false,
            editCount: 0,
            originalAmount: newAmount,
            originalDate: currentTimeString,
            originalDescription: `${machineName} (${Math.floor(Math.abs(hoursDifference))}:${Math.floor((Math.abs(hoursDifference) % 1) * 60).toString().padStart(2, '0')} ${hoursDifference > 0 ? 'artış' : 'azalış'}) - Puantaj: ${shortPuantajCode}`
          };
          
          currentHistory.push(newHistoryEntry);
        }
        
        // Yeni toplam amount'ı hesapla (HopsPlus mantığı)
        const newTotalAmount = currentHistory
          .filter(h => !h.isInfoOnly)
          .reduce((total, h) => total + (parseFloat(h.amount) || 0), 0);
        
        // Firebase'e kaydet
        transaction.set(debtRef, {
          amount: newTotalAmount,
          history: currentHistory,
          lastUpdated: currentTimeString,
          customerName: customerName
        });
        
        console.log('✅ HopsPlus mantığı - Puantaj düzenleme tamamlandı');
      });
      
    } catch (error) {
      console.error('❌ HopsPlus mantığı - Puantaj düzenleme hatası:', error);
      throw error;
    }
  };

  const handleEditSubmit = async () => {
    if (!selectedPuantaj || !auth.currentUser?.email) return;

    // 🔒 ÇOKLU ÇALIŞMA ENGELLEME - Eğer zaten PDF oluşturuluyorsa işlemi durdur
    if (isPdfRegeneratingLoading || isPdfPreviewOpen) {
      console.warn('⚠️ PDF zaten oluşturuluyor veya önizleme açık, yeni işlem engellendi');
      return;
    }

    // Form değerlerini state'ten al (artık controlled component kullanıyoruz)
    const formData = { ...editFormData };
    
    console.log('🔧 handleEditSubmit başladı:', {
      'Puantaj ID': selectedPuantaj.id,
      'ESKİ Müşteri': selectedPuantaj['Müşteri Adı'],
      'YENİ Müşteri': formData['Müşteri Adı'],
      'Müşteri Değişti mi': selectedPuantaj['Müşteri Adı'] !== formData['Müşteri Adı'] ? 'EVET' : 'Hayır',
      'PDF URL var mı': selectedPuantaj['PDF URL'] ? 'Evet' : 'Hayır'
    });
    
    // Tarih alanını DD.MM.YYYY formatına dönüştür
    if (formData['Tarih']) {
      const parsed = parseFlexible(formData['Tarih']);
      if (parsed) {
        formData['Tarih'] = formatTrDateOnly(parsed);
      }
    }

    // Saat validasyonu
    const timeFields = ['1. Başlangıç Saati', '1. Bitiş Saati', '2. Başlangıç Saati', '2. Bitiş Saati'];
    for (const field of timeFields) {
      const timeValue = formData[field];
      if (timeValue && timeValue.trim() !== '') {
        // HH:MM formatını kontrol et
        if (!timeValue.match(/^\d{2}:\d{2}$/)) {
          setError(`${field} geçerli bir saat formatında olmalıdır (HH:MM)`);
          setAlertOpen(true);
          return;
        }
        
        const [hours, minutes] = timeValue.split(':').map(Number);
        
        // Saat kontrolü (0-23)
        if (hours < 0 || hours > 23) {
          setError(`${field}: Saat değeri 00-23 arasında olmalıdır (Girilen: ${hours})`);
          setAlertOpen(true);
          return;
        }
        
        // Dakika kontrolü (0-59)
        if (minutes < 0 || minutes > 59) {
          setError(`${field}: Dakika değeri 00-59 arasında olmalıdır (Girilen: ${minutes})`);
          setAlertOpen(true);
          return;
        }
      }
    }

    // Eski ve yeni çalışma saatlerini hesapla
    const oldWorkingHours = calculateWorkingHours(selectedPuantaj);
    const newWorkingHours = calculateWorkingHours(formData);
    const hoursDifference = newWorkingHours - oldWorkingHours;

    console.log('Puantaj güncelleniyor:', selectedPuantaj.id);
    console.log('Çalışma saati değişimi:', {
      eskiSaat: oldWorkingHours,
      yeniSaat: newWorkingHours,
      fark: hoursDifference
    });

    // PDF önizleme için verileri hazırla (Firebase'e kaydetmeden)
    const updatedPuantajForPreview = {
      ...selectedPuantaj,
      ...formData,
      updatedAt: toIsoUtcString(new Date()),
      updatedBy: auth.currentUser.email
    };
    
    console.log('🔍 PDF oluşturma veri analizi:', {
      'selectedPuantaj Müşteri': selectedPuantaj['Müşteri Adı'],
      'formData Müşteri': formData['Müşteri Adı'],
      'updatedPuantajForPreview Müşteri': updatedPuantajForPreview['Müşteri Adı'],
      'Müşteri değişti mi': selectedPuantaj['Müşteri Adı'] !== formData['Müşteri Adı'] ? 'EVET' : 'Hayır'
    });
    
    // Pending update'leri kaydet (Firebase'e kaydetmek için)
    setPendingPuantajUpdate(updatedPuantajForPreview);
    setPendingFormData(formData);
    
    // Saat farkını da pending olarak kaydet
    setPendingHoursDifference(hoursDifference);

    try {
      
      // Düzenleme modalını hemen kapat
      setIsEditModalOpen(false);
      
      // Önce state'leri temizle
      setPreviewPdfUrl(null);
      setPendingTempFileName(null);
      setPendingOriginalFileName(null);
      setPendingTempStoragePath(null);
      setPendingOriginalStoragePath(null);
      
      // Önceki timeout varsa temizle
      if (loadingTimeoutRef.current) {
        clearTimeout(loadingTimeoutRef.current);
        loadingTimeoutRef.current = null;
        console.log('🧹 Önceki loading timeout temizlendi');
      }
      
      // Loading modalını gecikmeli göster (sadece işlem uzun sürerse)
      const newTimeout = setTimeout(() => {
        console.log('⏳ TIMEOUT TETİKLENDİ - Loading modal açılıyor');
        setIsPdfRegeneratingLoading(true);
        console.log('⏳ PDF oluşturma uzun sürdüğü için loading modal gösteriliyor');
      }, 300); // 300ms sonra göster
      
      loadingTimeoutRef.current = newTimeout;
      
      // 🎯 YARATICI ÇÖZÜM: Eski PDF'den imza çıkarma ve yeni PDF'e taşıma
      try {
        let extractedSignature = null;
        
        // Eski PDF'den imza çıkarmaya çalış
        if (selectedPuantaj['PDF URL'] && selectedPuantaj['PDF URL'].trim() !== '') {
          console.log('🔍 Eski PDF\'den imza çıkarılıyor:', selectedPuantaj['PDF URL']);
          
          // Yerel dosya yolu kontrolü - iOS simulatör veya cihaz dosya yolları
          const isLocalFile = selectedPuantaj['PDF URL'].startsWith('file://') || 
                             selectedPuantaj['PDF URL'].includes('/Library/Developer/CoreSimulator/') ||
                             selectedPuantaj['PDF URL'].includes('/Documents/') ||
                             selectedPuantaj['PDF URL'].includes('/tmp/');
          
          if (isLocalFile) {
            console.log('⚠️ Yerel dosya yolu tespit edildi, imza çıkarma atlanıyor:', selectedPuantaj['PDF URL']);
            console.log('📝 Firebase Storage URL\'si gerekli, imza olmadan PDF oluşturulacak');
            
            // Yerel dosya yolunu Firebase Storage URL'sine düzeltmeye çalış
            console.log('🔄 PDF URL\'si Firebase Storage URL\'sine düzeltilmeye çalışılıyor...');
            const fixedUrl = await fixLocalPdfUrl(selectedPuantaj.id, selectedPuantaj);
            if (fixedUrl) {
              console.log('✅ PDF URL başarıyla düzeltildi, imza çıkarma tekrar deneniyor');
              // Düzeltilmiş URL ile imza çıkarmayı dene
              try {
                const { extractSignatureFromOldPDF } = await import('../utils/pdfGenerator');
                extractedSignature = await extractSignatureFromOldPDF(fixedUrl);
                
                if (extractedSignature) {
                  console.log('✅ İmza başarıyla çıkarıldı (düzeltilmiş URL ile)!');
                } else {
                  console.log('⚠️ Düzeltilmiş URL\'de imza bulunamadı');
                }
              } catch (signatureError) {
                console.warn('⚠️ Düzeltilmiş URL ile imza çıkarma hatası:', signatureError.message);
                extractedSignature = null;
              }
            } else {
              console.log('⚠️ PDF URL düzeltme başarısız, imza olmadan devam ediliyor');
              extractedSignature = null;
            }
          } else {
            try {
              const { extractSignatureFromOldPDF } = await import('../utils/pdfGenerator');
              extractedSignature = await extractSignatureFromOldPDF(selectedPuantaj['PDF URL']);
              
              if (extractedSignature) {
                console.log('✅ İmza başarıyla çıkarıldı ve yeni PDF\'e taşınacak!');
              } else {
                console.log('⚠️ Eski PDF\'de imza bulunamadı');
              }
            } catch (signatureError) {
              console.warn('⚠️ İmza çıkarma hatası:', signatureError.message);
              console.log('📝 İmza olmadan PDF oluşturulacak');
              // İmza çıkarma başarısız olursa null olarak devam et
              extractedSignature = null;
            }
          }
        } else {
          console.log('⚠️ Eski PDF URL\'si mevcut değil, imza olmadan PDF oluşturulacak');
        }
        
        // 🔄 PDF oluşturmadan önce firma bilgilerini yeniden çek
        console.log('🔄 Güncel firma bilgileri alınıyor...');
        let currentUserInfo = userInfo;
        
        try {
          const userDocRef = doc(database, 'users', auth.currentUser.email);
          const userDoc = await getDoc(userDocRef);
          
          if (userDoc.exists()) {
            const userData = userDoc.data();
            currentUserInfo = {
              companyName: userData.companyName || userData.company || 'Firma Adı',
              companyAddress: userData.address || 'Firma Adresi',
              companyPhone: userData.phoneNumber || 'Telefon',
              logoUrl: userData.logoUrl || null,
              showPuantajPrice: userData.puantajfiyat === 'yes'
            };
            
            // Ana userInfo state'ini de güncelle
            setUserInfo(currentUserInfo);
            
            console.log('✅ Güncel firma bilgileri alındı:', {
              'Firma Adı': currentUserInfo.companyName,
              'Adres': currentUserInfo.companyAddress,
              'Telefon': currentUserInfo.companyPhone,
              'Logo var mı': currentUserInfo.logoUrl ? 'Evet' : 'Hayır',
              'Fiyat Göster': currentUserInfo.showPuantajPrice ? 'Evet' : 'Hayır',
              'Firebase puantajfiyat': userData.puantajfiyat
            });
          } else {
            console.warn('⚠️ Kullanıcı dokümanı bulunamadı, mevcut bilgiler kullanılacak');
          }
        } catch (userInfoError) {
          console.warn('⚠️ Firma bilgileri güncellenirken hata:', userInfoError.message);
          console.log('📝 Mevcut firma bilgileri kullanılacak');
        }
        
        // Geçici PDF oluştur (imza ile birlikte)
        console.log('📄 Geçici PDF oluşturuluyor...', {
          'İmza var mı': extractedSignature ? 'Evet' : 'Hayır',
          'Puantaj ID': selectedPuantaj?.id,
          'Müşteri Adı': updatedPuantajForPreview['Müşteri Adı'],
          'User Info': currentUserInfo ? 'Mevcut' : 'Null',
          'Firma Adı': currentUserInfo?.companyName
        });
        
        if (!updatedPuantajForPreview || !currentUserInfo || !auth.currentUser?.email) {
          throw new Error('PDF oluşturma için gerekli veriler eksik');
        }
        
        console.log('🎯🎯🎯 CREATE TEMPORARY PDF ÇAĞRILIYOR 🎯🎯🎯');
        console.log('📋 Selected Puantaj PDF URL (Orijinal):', selectedPuantaj['PDF URL']);
        console.log('📋 User Email:', auth.currentUser.email);
        console.log('📋 Puantaj Verisi:', {
          'Müşteri': updatedPuantajForPreview['Müşteri Adı'],
          'Makine': updatedPuantajForPreview['Makine İsmi'],
          'Puantaj No': updatedPuantajForPreview['Puantaj Sayısı']
        });
        
        const { createTemporaryPDF } = await import('../utils/pdfGenerator');
        const pdfResult = await createTemporaryPDF(
          updatedPuantajForPreview, 
          currentUserInfo, // Güncel firma bilgilerini kullan
          auth.currentUser.email,
          extractedSignature, // İmzayı geçir
          currentUserInfo.showPuantajPrice, // Fiyat gösterme ayarı
          selectedPuantaj['PDF URL'] // Orijinal PDF URL'sini geçir
        );
        
        console.log('🎯 CREATE TEMPORARY PDF SONUCU:', pdfResult);
        
        console.log('📄 PDF oluşturma sonucu:', {
          'PDF URL': pdfResult.pdfURL ? 'Mevcut' : 'Null',
          'Temp Filename': pdfResult.tempFileName,
          'Original Filename': pdfResult.originalFileName
        });
        
        if (!pdfResult.pdfURL || !pdfResult.tempFileName) {
          throw new Error('PDF oluşturma sonucu geçersiz');
        }
        
        // PDF başarıyla oluşturulduktan SONRA state'leri güncelle
        setPreviewPdfUrl(pdfResult.pdfURL);
        setPendingTempFileName(pdfResult.tempFileName);
        setPendingOriginalFileName(pdfResult.originalFileName);
        setPendingTempStoragePath(pdfResult.tempStoragePath);
        setPendingOriginalStoragePath(pdfResult.originalStoragePath);
        
        // 🔄 MODAL GEÇİŞİ - Loading timeout'unu temizle ve önizleme aç
        if (loadingTimeoutRef.current) {
          clearTimeout(loadingTimeoutRef.current);
          loadingTimeoutRef.current = null;
          console.log('🧹 Loading timeout temizlendi (başarılı)');
        }
        console.log('🔄 Modal geçişi yapılıyor: Loading -> Önizleme (hızlı)');
        
        // Loading modal'ı kapat ve önizleme modal'ını aç
        console.log('🟢 Loading modal KAPANIYOR (başarılı)');
        setIsPdfRegeneratingLoading(false);
        setIsPdfPreviewOpen(true);
        
        console.log('✅ Geçici PDF oluşturuldu ve önizleme modalı açıldı:', pdfResult.tempFileName);
        
      } catch (pdfError) {
        console.error('❌ Önizleme PDF hatası:', pdfError);
        
        // 🔄 HATA DURUMU MODAL YÖNETİMİ - Timeout temizle ve edit aç
        if (loadingTimeoutRef.current) {
          clearTimeout(loadingTimeoutRef.current);
          loadingTimeoutRef.current = null;
          console.log('🧹 Loading timeout temizlendi (hata)');
        }
        console.log('🔄 Hata nedeniyle modal geçişi: Loading -> Edit');
        
        // Loading modal'ı kapat ve edit modal'ını aç
        console.log('🔴 Loading modal KAPANIYOR (hata)');
        setIsPdfRegeneratingLoading(false);
        setIsEditModalOpen(true);
        setError(`PDF önizlemesi oluşturulamadı: ${pdfError.message}`);
        setAlertOpen(true);
        
        // Pending state'leri temizle
        setPendingPuantajUpdate(null);
        setPendingFormData(null);
        setPendingHoursDifference(0);
      }
      
    } catch (error) {
      console.error('🚨 handleEditSubmit ana hata:', error);
      console.error('Hata detayı:', {
        message: error.message,
        stack: error.stack,
        'selectedPuantaj ID': selectedPuantaj?.id,
        'Auth User': auth.currentUser?.email
      });
      
      // 🔄 ANA HATA DURUMU MODAL YÖNETİMİ - Timeout temizle ve edit aç
      if (loadingTimeoutRef.current) {
        clearTimeout(loadingTimeoutRef.current);
        loadingTimeoutRef.current = null;
        console.log('🧹 Loading timeout temizlendi (ana hata)');
      }
      console.log('🔄 Ana hata nedeniyle modal geçişi: Loading -> Edit');
      
      // Loading modal'ı kapat ve edit modal'ını aç
      console.log('🔴 Loading modal KAPANIYOR (ana hata)');
      setIsPdfRegeneratingLoading(false);
      setIsEditModalOpen(true);
      setError(`Puantaj güncellenirken bir hata oluştu: ${error.message}`);
      setAlertOpen(true);
      
      // Pending state'leri temizle
      setPendingPuantajUpdate(null);
      setPendingFormData(null);
      setPendingHoursDifference(0);
    }
  };

  // Silme işlemi fonksiyonları
  const handleDeleteClick = (puantaj) => {
    setPuantajToDelete(puantaj);
    setIsDeleteModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    if (!puantajToDelete) return;
  
    const { id, customerName } = puantajToDelete;
  
    console.log("🗑️ Silinecek puantaj:", puantajToDelete);
    console.log("📋 Puantaj ID:", id);
    console.log("📋 Müşteri Adı:", customerName);
    console.log("📋 PDF URL:", puantajToDelete.pdfUrl);
    console.log("📋 PDF Ref:", puantajToDelete.pdfRef);
    console.log("📋 PDF Name:", puantajToDelete.pdfName);
  
    const db = getFirestore();
    const user = auth.currentUser;
  
    if (!user) {
      setError("Kullanıcı oturumu bulunamadı.");
      setIsDeleteModalOpen(false);
      return;
    }
  
    console.log("👤 Kullanıcı email:", user.email);
  
    try {
      // 1. Cari Kasa'dan puantaja karşılık gelen borcu sil
      const customerRef = collection(db, `users/${user.email}/customerList`);
      const customerQuery = query(customerRef, where("Müşteri Adı", "==", customerName));
      const customerSnapshot = await getDocs(customerQuery);

      let deletedCariInfo = null; // Silinen cari bilgilerini sakla

      if (!customerSnapshot.empty) {
        const customerDoc = customerSnapshot.docs[0];
        const customerId = customerDoc.id;
        const debtRef = doc(db, `users/${user.email}/customerList/${customerId}/debt/current`);

        deletedCariInfo = await runTransaction(db, async (transaction) => {
          const debtDoc = await transaction.get(debtRef);

          if (!debtDoc.exists()) {
            console.warn(`❌ Bu müşteri için borç belgesi bulunamadı: ${customerName}`);
            return;
          }

          const debtData = debtDoc.data();
          const history = debtData.history || [];
          
          // Sözleşme numarasından puantaj bilgilerini çıkar
          const pdfName = puantajToDelete.pdfName || '';
          console.log(`🔍 PDF adı: ${pdfName}`);
          
          // PDF adından sözleşme numarasını ve makine adını çıkar
          // Örnek: "MNT-4-0387.pdf" -> makine: "MNT-4", sözleşme: "0387"
          let machineName = '';
          let contractNumber = '';
          
          if (pdfName) {
            // PDF uzantısını kaldır
            const nameWithoutExtension = pdfName.replace('.pdf', '');
            
            // Son tire sonrasını sözleşme numarası olarak al
            const lastDashIndex = nameWithoutExtension.lastIndexOf('-');
            if (lastDashIndex !== -1) {
              contractNumber = nameWithoutExtension.substring(lastDashIndex + 1);
              machineName = nameWithoutExtension.substring(0, lastDashIndex);
            }
          }
          
          // Fallback: Puantaj ID'sinin son 8 karakteri
          const shortPuantajCode = id ? id.slice(-8) : null;
          
          console.log(`🔍 Arama kriterleri:`);
          console.log(`   - PDF adı: ${pdfName}`);
          console.log(`   - Makine adı: ${machineName}`);
          console.log(`   - Sözleşme numarası: ${contractNumber}`);
          console.log(`   - Fallback puantaj kodu: ${shortPuantajCode}`);
          console.log(`📊 Toplam cari geçmiş kayıt sayısı: ${history.length}`);

          let totalAmountToDelete = 0;
          let deletedEntriesCount = 0;
          const deletedEntries = [];

          // Tüm eşleşen kayıtları bul ve sil
          const newHistory = history.filter(entry => {
            let isMatch = false;
            const entryDescription = entry.description || '';
            
            // 1. Öncelik: Sözleşme numarası ve makine adı ile eşleştirme
            if (contractNumber && machineName) {
              // Açıklamada hem sözleşme numarası hem makine adı var mı?
              const hasContractNumber = entryDescription.includes(contractNumber);
              const hasMachineName = entryDescription.includes(machineName);
              
              if (hasContractNumber && hasMachineName) {
                isMatch = true;
                console.log(`✅ Sözleşme numarası ve makine adı eşleşmesi: ${entryDescription}`);
              }
            }
            
            // 2. Fallback: Puantaj kodu ile eşleştirme
            if (!isMatch && shortPuantajCode) {
              const matchesPuantajCode = entry.puantajCode && entry.puantajCode === shortPuantajCode;
              const matchesDescription = entryDescription.includes(shortPuantajCode);
              
              if (matchesPuantajCode || matchesDescription) {
                isMatch = true;
                console.log(`✅ Puantaj kodu eşleşmesi: ${entryDescription}`);
              }
            }
            
            // 3. Ek kontrol: Sadece sözleşme numarası ile eşleştirme (makine adı yoksa)
            if (!isMatch && contractNumber && entryDescription.includes(contractNumber)) {
              isMatch = true;
              console.log(`✅ Sadece sözleşme numarası eşleşmesi: ${entryDescription}`);
            }
            
            if (isMatch) {
              const entryAmount = typeof entry.amount === 'number' ? entry.amount : 0;
              totalAmountToDelete += entryAmount;
              deletedEntriesCount++;
              
              // İlk eşleşen cari bilgisini tam olarak sakla (geri yükleme için)
              if (!deletedCariInfo && entry.type === 'increase') {
                deletedCariInfo = {
                  amount: entry.amount,
                  date: entry.date,
                  description: entry.description,
                  machineName: entry.machineName || machineName,
                  machineHours: entry.machineHours,
                  hourlyRate: entry.hourlyRate,
                  puantajCode: entry.puantajCode || shortPuantajCode,
                  type: entry.type
                };
                console.log(`💾 Cari bilgisi kaydedildi:`, deletedCariInfo);
              }
              
              deletedEntries.push({
                description: entry.description,
                amount: entryAmount,
                date: entry.date,
                type: entry.type
              });
              console.log(`🗑️ Silinecek cari kayıt: ${entry.description} - ${entryAmount} TL`);
              return false; // Bu kaydı çıkar
            }
            return true; // Bu kaydı koru
          });

          if (deletedEntriesCount > 0) {
            const currentAmount = typeof debtData.amount === 'number' ? debtData.amount : 0;
            const newAmount = Math.max(0, currentAmount - totalAmountToDelete);
            
            // Sadece filtrelenmiş history'yi kullan (silme kaydı EKLEMİYORUZ)
            transaction.set(debtRef, {
              history: newHistory, // Sadece silinen kayıtları çıkarmış olan history
              amount: newAmount,
              lastUpdated: toIsoUtcString(new Date()),
              customerName: customerName
            }, { merge: true });

            console.log(`✅ Cari işlem(ler) başarıyla silindi:`);
            console.log(`   📍 Müşteri: ${customerName}`);
            console.log(`   📍 PDF adı: ${pdfName}`);
            console.log(`   📍 Sözleşme numarası: ${contractNumber}`);
            console.log(`   📍 Makine adı: ${machineName}`);
            console.log(`   📍 Silinen kayıt sayısı: ${deletedEntriesCount}`);
            console.log(`   📍 Toplam silinen tutar: ${totalAmountToDelete} TL`);
            console.log(`   📍 Eski bakiye: ${currentAmount} TL`);
            console.log(`   📍 Yeni bakiye: ${newAmount} TL`);
            console.log(`   📍 Silinen kayıtlar:`, deletedEntries);
            
            // Cari bilgisini döndür
            return deletedCariInfo;
          } else {
            console.warn(`⚠️ Bu puantaja ait cari işlem bulunamadı.`);
            console.log(`🔍 Arama kriterleri:`);
            console.log(`   - PDF adı: ${pdfName}`);
            console.log(`   - Sözleşme numarası: ${contractNumber || 'Yok'}`);
            console.log(`   - Makine adı: ${machineName || 'Yok'}`);
            console.log(`   - Fallback puantaj kodu: ${shortPuantajCode || 'Yok'}`);
            console.log(`📋 Mevcut cari geçmiş kayıtları:`);
            history.forEach((entry, index) => {
              console.log(`   ${index + 1}. ${entry.description} - ${entry.amount} TL - Kod: ${entry.puantajCode || 'Yok'}`);
            });
            
            return null; // Cari bilgisi bulunamadı
          }
        });
      } else {
        console.warn(`❌ Müşteri bulunamadı: ${customerName}`);
      }
  
      // 2. Puantajı silinen_puantajlar koleksiyonuna taşı
      // PDF URL'ini al - pdfUrl veya pdfRef'ten
      let pdfUrl = puantajToDelete.pdfUrl;
      if (!pdfUrl && puantajToDelete.pdfRef) {
        try {
          pdfUrl = await getDownloadURL(puantajToDelete.pdfRef);
          console.log("📋 PDF URL pdfRef'ten alındı:", pdfUrl);
        } catch (urlError) {
          console.error("PDF URL alınamadı:", urlError);
        }
      }
      
      let newPdfUrl = pdfUrl; // Varsayılan olarak mevcut URL'i kullan
      
      // PDF varsa orijinal konumunu sakla
      // NOT: PDF'leri taşımak yerine orijinal konumlarında bırakıyoruz
      // Çünkü CORS politikaları nedeniyle client-side'da PDF taşıma yapamıyoruz
      if (pdfUrl) {
        console.log(`📄 PDF URL'i saklanıyor: ${pdfUrl}`);
        newPdfUrl = pdfUrl; // Orijinal URL'i koru
        
        // İleride server-side function ile taşıma yapılabilir
        // Şimdilik PDF orijinal konumunda kalacak
      }
      
      // Silinen puantaj verilerini hazırla (PDF olsun veya olmasın)
      // pdfRef'i kaldır çünkü Firebase Reference objesi Firestore'a kaydedilemez
      const { pdfRef, ...puantajDataWithoutRef } = puantajToDelete;
      const deletedPuantajData = {
        ...puantajDataWithoutRef,
        pdfUrl: newPdfUrl,
        pdfName: puantajToDelete.pdfName || `puantaj_${id}.pdf`,
        deletedAt: toIsoUtcString(new Date()),
        deletedBy: user.email,
        originalId: id,
        // Cari bilgilerini ekle (geri yükleme için)
        deletedCariInfo: deletedCariInfo || null
      };
      
      // Silinen puantajları koleksiyonuna ekle
      console.log(`📝 Puantaj silinen_puantajlar koleksiyonuna ekleniyor...`);
      const deletedRef = doc(db, `users/${user.email}/silinen_puantajlar`, id);
      await setDoc(deletedRef, deletedPuantajData);
      console.log(`✅ Puantaj silinen_puantajlar koleksiyonuna eklendi`);
      
      // 3. Orijinal puantaj dökümanını sil
      console.log(`🗑️ Puantaj dökümanı siliniyor: ${id}`);
      await deleteDoc(doc(db, `users/${user.email}/timeSheets`, id));
      console.log(`✅ Puantaj dökümanı başarıyla silindi`);
  
      // 4. UI'ı güncelle
      setAllData(prev => prev.filter(item => item.id !== id));
      setFilteredData(prev => prev.filter(item => item.id !== id));
  
      setSuccessMessage('Puantaj çöp kutusuna taşındı! Cari geçmişten ilgili borç kayıtları da temizlendi.');
      setAlertOpen(true);
  
      console.log(`✅ Puantaj silme işlemi tamamlandı: ${id}`);
  
    } catch (error) {
      console.error("❌ Puantaj silinirken hata oluştu: ", error);
      console.error("❌ Hata detayı:", {
        message: error.message,
        code: error.code,
        stack: error.stack
      });
      setError(`Puantaj silinirken bir hata oluştu: ${error.message}`);
      setAlertOpen(true);
    }
  
    // Modalı kapat
    setIsDeleteModalOpen(false);
    setPuantajToDelete(null);
  };

  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
    setPuantajToDelete(null);
  };

  // PDF Önizleme Modal fonksiyonları
  const handlePdfPreviewApprove = async () => {
    if (!pendingPuantajUpdate || !pendingFormData || !auth.currentUser?.email) return;

    // 🔍 ÖNCE YENİ MÜŞTERİ KONTROLÜ YAP - Müşteri adı değişti mi ve mevcut değil mi?
    const oldCustomerName = selectedPuantaj['Müşteri Adı'];
    const newCustomerName = pendingFormData['Müşteri Adı'];
    
    if (oldCustomerName !== newCustomerName && newCustomerName && !checkIfCustomerExists(newCustomerName)) {
      console.log('🔥 Yeni müşteri tespit edildi, önce müşteri eklenmeli:', {
        eskiMüşteri: oldCustomerName,
        yeniMüşteri: newCustomerName,
        mevcutMu: checkIfCustomerExists(newCustomerName)
      });
      
      // Yeni müşteri adını kaydet ve modal'ı aç
      setNewCustomerFromPuantaj(newCustomerName.trim());
      
      // Müşteri ekleme modalını hemen aç (PDF modal üstünde)
      setIsAddCustomerModalOpen(true);
      
      // İşlemi durdur - PDF modal açık kalacak, müşteri eklendikten sonra tekrar buton'a basılacak
      return;
    }

    // Müşteri mevcut veya değişmedi, normal kaydetme işlemini yap
    try {
      const db = getFirestore();
      const puantajRef = doc(db, `users/${auth.currentUser.email}/timeSheets`, selectedPuantaj.id);
      
      // Firestore'da güncelle
      await setDoc(puantajRef, {
        ...pendingFormData,
        updatedAt: toIsoUtcString(new Date()),
        updatedBy: auth.currentUser.email
      }, { merge: true });
      
      // 🔄 MÜŞTERİ DEĞİŞİKLİĞİ KONTROLÜ VE BORÇ TRANSFERİ
      if (oldCustomerName !== newCustomerName) {
        console.log('🔄 Müşteri değişikliği tespit edildi, borç transferi yapılıyor...');
        
        const totalHours = calculateWorkingHours(pendingFormData);
        
        try {
          // Puantaj tarihini ISO formatına çevir
          let puantajDateISO = null;
          if (pendingFormData['Tarih']) {
            const parsed = parseFlexible(pendingFormData['Tarih']);
            puantajDateISO = parsed ? toIsoUtcString(parsed) : toIsoUtcString(new Date());
          }
          
          await handleCustomerChangeDebtTransfer(
            oldCustomerName,
            newCustomerName,
            pendingFormData['Makine İsmi'] || selectedPuantaj['Makine İsmi'],
            totalHours,
            selectedPuantaj.id,
            puantajDateISO // Puantaj tarihini geç
          );
          console.log('✅ Müşteri değişikliği borç transferi tamamlandı');
        } catch (transferError) {
          console.error('❌ Borç transferi hatası:', transferError);
          // Hata durumunda kullanıcıyı bilgilendir ama işlemi durdurma
          setError(`Borç transferi sırasında hata oluştu: ${transferError.message}`);
          setAlertOpen(true);
        }
      }
      
      // Normal saat değişikliği güncellemesi (sadece aynı müşteri için)
      else if (Math.abs(pendingHoursDifference) > 0.01) {
        // Puantaj tarihini ISO formatına çevir
        let puantajDateISO = null;
        if (pendingFormData['Tarih']) {
          const parsed = parseFlexible(pendingFormData['Tarih']);
          puantajDateISO = parsed ? toIsoUtcString(parsed) : toIsoUtcString(new Date());
        }
        
        await updateCustomerDebt(
          pendingFormData['Müşteri Adı'] || selectedPuantaj['Müşteri Adı'], 
          pendingFormData['Makine İsmi'] || selectedPuantaj['Makine İsmi'], 
          pendingHoursDifference,
          selectedPuantaj.id,
          puantajDateISO // Yeni puantaj tarihi
        );
      }
      
      // 🔄 PUANTAJ TARİH DEĞİŞİKLİĞİ KONTROLÜ VE CARİ GEÇMİŞİ SENKRONIZASYONU
      // Eğer sadece tarih değişmişse (saat değişmemişse) cari geçmişindeki tarihi de güncelle
      const oldDate = selectedPuantaj['Tarih'];
      const newDate = pendingFormData['Tarih'];
      
      if (oldDate !== newDate && Math.abs(pendingHoursDifference) < 0.01) {
        console.log('📅 Puantaj tarih değişikliği tespit edildi (saat değişikliği yok):', {
          eskiTarih: oldDate,
          yeniTarih: newDate,
          müşteri: pendingFormData['Müşteri Adı'] || selectedPuantaj['Müşteri Adı']
        });
        
        // Puantaj kodunu al
        const shortPuantajCode = selectedPuantaj.id ? selectedPuantaj.id.slice(-8) : 'BILINMEYEN';
        
        // Yeni tarihi ISO formatına çevir
        let newDateISO = null;
        if (newDate) {
          const parsed = parseFlexible(newDate);
          newDateISO = parsed ? toIsoUtcString(parsed) : toIsoUtcString(new Date());
        }
        
        if (newDateISO) {
          try {
            const dateUpdateSuccess = await updateDebtHistoryEntryDate(
              pendingFormData['Müşteri Adı'] || selectedPuantaj['Müşteri Adı'],
              shortPuantajCode,
              newDateISO
            );
            
            if (dateUpdateSuccess) {
              console.log('✅ Cari geçmişi tarihi başarıyla güncellendi');
            } else {
              console.warn('⚠️ Cari geçmişi tarih güncelleme başarısız (belki ilgili işlem bulunamadı)');
            }
          } catch (dateError) {
            console.error('❌ Cari geçmişi tarih güncelleme hatası:', dateError);
          }
        }
      }

      // Local state'i güncelle
      const updatedPuantajWithFinalUrl = { ...pendingPuantajUpdate };
      
      setAllData(prevData => 
        prevData.map(item => 
          item.id === selectedPuantaj.id ? updatedPuantajWithFinalUrl : item
        )
      );
      
      setFilteredData(prevData => 
        prevData.map(item => 
          item.id === selectedPuantaj.id ? updatedPuantajWithFinalUrl : item
        )
      );
      
      // 🔑 ÖNEMLİ: selectedPuantaj'ı da güncelle ki bir sonraki düzenleme için hazır olsun
      setSelectedPuantaj(updatedPuantajWithFinalUrl);

      // Geçici PDF'i kalıcı yap ve URL'yi güncelle
      if (pendingTempStoragePath && pendingOriginalStoragePath) {
        try {
          console.log('🚀🚀🚀 GEÇİCİ PDF KALICI YAPILIYOR 🚀🚀🚀');
          console.log('📤 Pending Temp Storage Path:', pendingTempStoragePath);
          console.log('📤 Pending Original Storage Path:', pendingOriginalStoragePath);
          console.log('📤 Selected Puantaj PDF URL:', selectedPuantaj['PDF URL']);
          
          const { confirmTemporaryPDF } = await import('../utils/pdfGenerator');
          const finalPdfResult = await confirmTemporaryPDF(
            pendingTempStoragePath,
            pendingOriginalStoragePath
          );
          
          console.log('✅ Final PDF Result:', finalPdfResult);
          
          // Kalıcı PDF URL'sini Firestore'da güncelle
          await setDoc(puantajRef, {
            'PDF URL': finalPdfResult.pdfURL
          }, { merge: true });
          
          // 🔑 ÖNEMLİ: updatedPuantajWithFinalUrl'ye de PDF URL'sini ekle
          updatedPuantajWithFinalUrl['PDF URL'] = finalPdfResult.pdfURL;
          
          console.log('📄 Geçici PDF kalıcı yapıldı ve Firestore güncellendi:', finalPdfResult.fileName);
        } catch (pdfError) {
          console.error('❌ Geçici PDF kalıcı yapma hatası:', pdfError);
          // Hata durumunda en azından mevcut URL'yi kaydet
          if (previewPdfUrl) {
            let cleanPdfUrl = previewPdfUrl.replace(/&t=\d+/g, '').replace(/\?t=\d+$/g, '');
            await setDoc(puantajRef, {
              'PDF URL': cleanPdfUrl
            }, { merge: true });
            
            // 🔑 ÖNEMLİ: updatedPuantajWithFinalUrl'ye de temiz PDF URL'sini ekle
            updatedPuantajWithFinalUrl['PDF URL'] = cleanPdfUrl;
          }
        }
      }

      // Başarı mesajı göster
      let successMsg = 'Puantaj başarıyla güncellendi! PDF yeniden oluşturuldu.';
      
      if (oldCustomerName !== newCustomerName) {
        successMsg += ' Müşteri değişikliği nedeniyle borç transferi yapıldı.';
      } else if (Math.abs(pendingHoursDifference) > 0.01) {
        successMsg += ' Cari kasa da güncellendi.';
      }
      
      setSuccessMessage(successMsg);
      setAlertOpen(true);
      
      // Modal'ları kapat ve temizle (SADECE İŞLEM BAŞARILI OLURSA)
      setIsPdfPreviewOpen(false);
      setIsEditModalOpen(false);
      setPendingPuantajUpdate(null);
      setPendingFormData(null);
      setPendingHoursDifference(0);
      setPendingTempFileName(null);
      setPendingOriginalFileName(null);
      setPendingTempStoragePath(null);
      setPendingOriginalStoragePath(null);
      setPreviewPdfUrl(null);
      
      // 5 saniye sonra mesajı temizle
      setTimeout(() => {
        setSuccessMessage('');
        setAlertOpen(false);
      }, 5000);
      
    } catch (error) {
      console.error('Puantaj onaylanırken hata:', error);
      setError('Puantaj onaylanırken bir hata oluştu.');
      setAlertOpen(true);
    }
  };

  const handlePdfPreviewReject = async () => {
    // Geçici PDF'i sil
    if (pendingTempStoragePath) {
      try {
        const { deleteTemporaryPDF } = await import('../utils/pdfGenerator');
        await deleteTemporaryPDF(pendingTempStoragePath);
        console.log('🗑️ Geçici PDF silindi:', pendingTempStoragePath);
      } catch (error) {
        console.error('❌ Geçici PDF silme hatası:', error);
      }
    }
    
    // Sadece PDF önizleme modalını kapat, düzenleme modalını açık bırak
    setIsPdfPreviewOpen(false);
    setPendingPuantajUpdate(null);
    setPendingFormData(null);
    setPendingHoursDifference(0);
    setPendingTempFileName(null);
    setPendingOriginalFileName(null);
    setPendingTempStoragePath(null);
    setPendingOriginalStoragePath(null);
    setPreviewPdfUrl(null);
    
    // Edit modal'ını KAPATMA - kullanıcı düzenleme yapmaya devam edebilsin
    // setIsEditModalOpen(false); // Bu satırı kaldırdık
    
    console.log('PDF önizlemesi reddedildi, geçici PDF silindi, düzenleme modalına geri dönüldü');
  };

  const calculateHoursDifference = (oldData, newData) => {
    // Eski ve yeni saatleri hesapla
    const oldHours = calculateTotalHours(oldData);
    const newHours = calculateTotalHours(newData);
    return newHours - oldHours;
  };

  const calculateTotalHours = (data) => {
    const start1 = formatTime(data['1. Başlangıç Saati']);
    const end1 = formatTime(data['1. Bitiş Saati']);
    const start2 = formatTime(data['2. Başlangıç Saati']);
    const end2 = formatTime(data['2. Bitiş Saati']);

    let totalMinutes = 0;
    if (start1 && end1) totalMinutes += calculateDuration(start1, end1);
    if (start2 && end2) totalMinutes += calculateDuration(start2, end2);

    // Sonucu saat cinsinden döndür (ondalık olarak - borç hesaplamaları için)
    return totalMinutes / 60;
  };

  // Müşteri seçim fonksiyonları
  const fetchAllCustomersForSelection = async () => {
    if (!auth.currentUser?.email) return;

    try {
      const db = getFirestore();
      const customerListRef = collection(db, COLLECTION_PATHS.USER_CUSTOMERS(auth.currentUser.email));
      const snapshot = await getDocs(customerListRef);
      
      const customers = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        // Durum alanını standartlaştır (renk kodlaması için)
        status: doc.data()['Onay'] || 'Onay Bekliyor'
      }));
      
      // Sadece onaylanmış müşterileri göster
      const approvedCustomers = customers.filter(customer => 
        customer['Onay'] === 'Onaylandı'
      );
      
      console.log('Müşteri seçim listesi yüklendi:', {
        toplam: customers.length,
        onaylanmış: approvedCustomers.length,
        ilkMüşteri: approvedCustomers[0]
      });
      
      setAllCustomersForSelection(approvedCustomers);
    } catch (error) {
      console.error('Müşteri listesi getirilemedi:', error);
    }
  };

  const handleSelectCustomerFromTable = (customer) => {
    console.log('👤 Müşteri seçildi:', customer);
    
    const customerName = customer['Müşteri Adı'] || '';
    console.log('👤 Seçilen müşteri adı:', customerName);
    
    // State'i güncelle (artık controlled component olduğu için sadece state güncellemesi yeterli)
    setEditFormData(prev => {
      const newFormData = {
        ...prev,
        'Müşteri Adı': customerName
      };
      console.log('📋 Eski form state:', prev);
      console.log('📋 Güncellenen form state:', newFormData);
      console.log('📋 Müşteri adı alanı güncellendi:', prev['Müşteri Adı'], '=>', customerName);
      return newFormData;
    });
    
    // Dropdown'ı kapat
    setIsCustomerSelectionOpen(false);
    console.log('📤 Dropdown kapandı - Modal güncellenmeli');
  };

  const toggleCustomerSelection = async () => {
    const newState = !isCustomerSelectionOpen;
    setIsCustomerSelectionOpen(newState);
    
    console.log('Müşteri seçim dropdown:', newState ? 'açıldı' : 'kapandı');
    
    if (newState && allCustomersForSelection.length === 0) {
      console.log('Müşteri listesi yükleniyor...');
      await fetchAllCustomersForSelection();
    }
  };

  const toggleMachineSelection = () => {
    setIsMachineSelectionOpen(!isMachineSelectionOpen);
    console.log('Makine seçim dropdown:', !isMachineSelectionOpen ? 'açıldı' : 'kapandı');
  };

  const toggleOperatorSelection = () => {
    setIsOperatorSelectionOpen(!isOperatorSelectionOpen);
    console.log('Operatör seçim dropdown:', !isOperatorSelectionOpen ? 'açıldı' : 'kapandı');
  };

  const handleSelectMachine = (machine) => {
    console.log('Makine seçildi:', machine);
    setEditFormData(prev => ({
      ...prev,
      'Makine İsmi': machine.value
    }));
    setIsMachineSelectionOpen(false);
  };

  const handleSelectOperator = (operator) => {
    console.log('Operatör seçildi:', operator);
    setEditFormData(prev => ({
      ...prev,
      'Operatör Adı': operator.value
    }));
    setIsOperatorSelectionOpen(false);
  };

  // Modal kapanma handler'ı
  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
    setIsCustomerSelectionOpen(false);
    setIsMachineSelectionOpen(false);
    setIsOperatorSelectionOpen(false);
    setEditFormData({});
  };



  // DeleteModal bileşeni
  const DeleteModal = () => (
    isDeleteModalOpen && (
      <div className="delete-modal" onClick={handleDeleteCancel}>
        <div className="delete-modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Puantaj Silme Onayı</h3>
          </div>
          <div className="modal-body">
            <p>Bu puantajı silmek istediğinizden emin misiniz?</p>
            {puantajToDelete && (
              <div className="puantaj-info">
                <p><strong>Müşteri:</strong> {puantajToDelete.customerName || puantajToDelete['Müşteri Adı'] || '-'}</p>
                <p><strong>Makine:</strong> {puantajToDelete['Makine İsmi'] || '-'}</p>
                <p><strong>Operatör:</strong> {puantajToDelete['Operatör Adı'] || '-'}</p>
                <p><strong>Tarih:</strong> {puantajToDelete['Tarih'] || '-'}</p>
              </div>
            )}
            <div className="warning-info">
              <p className="info-text">⚠️ Bu işlem şunları yapacak:</p>
              <ul className="info-list">
                <li>Puantaj kaydı silinecek</li>
                <li>Müşterinin cari geçmişinden ilgili borç kayıtları silinecek</li>
                <li>Cari kasa bakiyesi otomatik olarak güncellenecek</li>
              </ul>
            </div>
            <p className="warning-text">Bu işlem geri alınamaz!</p>
          </div>
          <div className="modal-buttons">
            <Button variant="outlined" onClick={handleDeleteCancel}>
              İptal
            </Button>
            <Button variant="contained" color="error" onClick={handleDeleteConfirm}>
              Sil
            </Button>
          </div>
        </div>
      </div>
    )
  );

  // PDF Loading Modal bileşeni
  const PDFLoadingModal = () => {
    return isPdfRegeneratingLoading && (
      <div className="pdf-loading-modal">
        <div className="pdf-loading-content">
          <div className="loading-animation">
            <div className="spinner"></div>
          </div>
          <h3>PDF Yeniden Oluşturuluyor</h3>
          <p>Lütfen bekleyin, güncellenmiş puantaj PDF'i hazırlanıyor...</p>
          <div className="loading-steps">
            <div className="step">📄 PDF oluşturuluyor</div>
            <div className="step">🔄 İmza taşınıyor</div>
            <div className="step">✨ Son kontroller yapılıyor</div>
          </div>
        </div>
      </div>
    );
  };

  // PDF URL'sini Firebase Storage URL'sine düzeltme fonksiyonu - Hibrit sistem ile güncellendi
  const fixLocalPdfUrl = async (puantajId, puantajData) => {
    try {
      // Puantaj verilerinden dosya adını oluştur
      const machineCode = puantajData['Makine İsmi'] || 'makine';
      const puantajNumber = puantajData['Puantaj Sayısı'] || 'puantaj';
      const contractNumber = `${machineCode}-${puantajNumber}`;
      const fileName = `${contractNumber}.pdf`;
      
      try {
        // Hibrit sistem ile PDF URL'ini al
        const firebaseUrl = await getPdfDownloadUrl(fileName);
        
        // Firestore'da PDF URL'sini güncelle
        const puantajRef = doc(database, `users/${auth.currentUser.email}/timeSheets`, puantajId);
        await setDoc(puantajRef, {
          'PDF URL': firebaseUrl
        }, { merge: true });
        
        console.log('✅ PDF URL Firebase Storage URL\'sine düzeltildi:', fileName);
        return firebaseUrl;
      } catch (error) {
        console.log('⚠️ Firebase Storage\'da PDF bulunamadı:', fileName);
        return null;
      }
    } catch (error) {
      console.error('❌ PDF URL düzeltme hatası:', error);
      return null;
    }
  };

  if (loading) {
    return <div>Yükleniyor...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  // Sıralama İkonları için Yardımcı Fonksiyon
  const renderSortIcon = (column) => {
    if (orderBy !== column) return null;
    return order === 'asc' ? ' 🔼' : ' 🔽';
  };

  return (
    <div className="puantajlar-container">
      <div className="company-info">
        <h2>Puantajlar</h2>
        <div className="user-details">
          <p><strong>Firma:</strong> {companyName}</p>
          <p><strong>E-posta:</strong> {userEmail}</p>
        </div>
      </div>

      <div className="filter-container">
        <div className="filters-row">
          <div className="date-filter">
            <label>Tarih Aralığı Seçin: </label>
            <div className="date-pickers">
              <DatePicker
                selected={startDate}
                onChange={debouncedSetStartDate}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                dateFormat="dd.MM.yyyy"
                placeholderText="Başlangıç Tarihi"
                locale="tr"
              />
              <DatePicker
                selected={endDate}
                onChange={debouncedSetEndDate}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                dateFormat="dd.MM.yyyy"
                placeholderText="Bitiş Tarihi"
                locale="tr"
              />
            </div>
          </div>

          <div className="customer-filter">
            <label>
              Müşteri Seçin: 
              {selectedCustomers.length > 0 && (
                <span className="selection-count">({selectedCustomers.length} seçili)</span>
              )}
            </label>
            <Select
              isMulti
              options={customerOptions}
              value={selectedCustomers}
              onChange={handleCustomerChange}
              onInputChange={(inputValue, actionMeta) => {
                if (actionMeta.action === 'input-change') {
                  return toTurkishUpperCase(inputValue);
                }
                return inputValue;
              }}
              placeholder="Müşteri Seçin"
              className="customer-select"
              classNamePrefix="react-select"
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              isSearchable
              maxMenuHeight={200}
            />
          </div>

          <div className="machine-filter">
            <label>
              Makine Adı Seçin: 
              {selectedMachines.length > 0 && (
                <span className="selection-count">({selectedMachines.length} seçili)</span>
              )}
            </label>
            <Select
              isMulti
              options={machineOptions}
              value={selectedMachines}
              onChange={handleMachineChange}
              onInputChange={(inputValue, actionMeta) => {
                if (actionMeta.action === 'input-change') {
                  return toTurkishUpperCase(inputValue);
                }
                return inputValue;
              }}
              placeholder="Makine Adı Seçin"
              className="machine-select"
              classNamePrefix="react-select"
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              isSearchable
              maxMenuHeight={200}
            />
          </div>

          <div className="operator-filter">
            <label>
              Operatör Adı Seçin: 
              {selectedOperators.length > 0 && (
                <span className="selection-count">({selectedOperators.length} seçili)</span>
              )}
            </label>
            <Select
              isMulti
              options={operatorOptions}
              value={selectedOperators}
              onChange={handleOperatorChange}
              onInputChange={(inputValue, actionMeta) => {
                if (actionMeta.action === 'input-change') {
                  return toTurkishUpperCase(inputValue);
                }
                return inputValue;
              }}
              placeholder="Operatör Adı Seçin"
              className="operator-select"
              classNamePrefix="react-select"
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              isSearchable
              maxMenuHeight={200}
            />
          </div>
        </div>

        <div className="button-group">
          <button onClick={handleSelectAll}>Hepsini Seç</button>
          <button onClick={handleDeselectAll}>Seçimleri Kaldır</button>
          <button
            onClick={() => setIsDownloadModalOpen(true)}
            disabled={selectedPdfs.length === 0 || loading}
            className="download-button-inline"
          >
            {loading ? 'İndiriliyor...' : `Seçili PDF'leri İndir (${selectedPdfs.length})`}
          </button>
        </div>

        <div className="right-buttons">
          <div className="calculation-row">
            <p className="result">{calculatedTotalHours}</p>
          </div>
          <div className="calculation-row">
            <p className="result">{totalHakedis}</p>
          </div>
        </div>
      </div>

      {sortedData.length > 0 && (
        <>
          {/* Pagination Info */}
          <div className="pagination-info">
            <p>
              Toplam {sortedData.length} puantajdan {startIndex + 1}-{Math.min(endIndex, sortedData.length)} arası gösteriliyor
            </p>
          </div>

          <div className="table-container">
            <table className="puantajlar-table">
              <thead>
                <tr>
                  <th>İşlemler</th>
                  <th onClick={() => handleSort('pdfName')} style={{ cursor: 'pointer' }}>
                    PDF / Sözleşme No {renderSortIcon('pdfName')}
                  </th>
                  <th onClick={() => handleSort('customerName')} style={{ cursor: 'pointer' }}>
                    Müşteri {renderSortIcon('customerName')}
                  </th>
                  <th onClick={() => handleSort('cariCode')} style={{ cursor: 'pointer' }}>
                    Cari Kod {renderSortIcon('cariCode')}
                  </th>
                  <th onClick={() => handleSort('Makine İsmi')} style={{ cursor: 'pointer' }}>
                    Makine {renderSortIcon('Makine İsmi')}
                  </th>
                  <th onClick={() => handleSort('Operatör Adı')} style={{ cursor: 'pointer' }}>
                    Operatör {renderSortIcon('Operatör Adı')}
                  </th>
                  {userInfo.showPuantajPrice && (
                    <th>💰 Fiyat</th>
                  )}
                  <th onClick={() => handleSort('Tarih')} style={{ cursor: 'pointer' }}>
                    Tarih {renderSortIcon('Tarih')}
                  </th>
                  <th>Detaylar</th>
                </tr>
              </thead>
              <tbody>
                {currentPageData.map((item, index) => (
                  <tr key={index}>
                    <td data-label="İşlemler" className="priority">
                      <div className="action-buttons">
                        <input
                          type="checkbox"
                          onChange={() => handleCheckboxChange(item.pdfName)}
                          checked={selectedPdfs.includes(item.pdfName)}
                        />
                        <StyledIconButton
                          size="medium"
                          onClick={() => handleEditClick(item)}
                          className="edit-button"
                          title="Düzenle"
                        >
                          <EditIcon />
                        </StyledIconButton>
                        <StyledIconButton
                          size="medium"
                          onClick={() => handleDeleteClick(item)}
                          className="delete-button"
                          title="Sil"
                        >
                          <DeleteIcon />
                        </StyledIconButton>
                      </div>
                    </td>
                    <td data-label="PDF / Sözleşme No" className="priority">
                      <button
                        className="link-button"
                        onClick={() => handlePdfPreview(item.pdfRef, item.pdfName)}
                      >
                        {item.pdfName}
                      </button>
                    </td>
                    <td data-label="Müşteri" className="priority">
                      {item.customerName || '-'}
                    </td>
                    <td data-label="Cari Kod" className="priority cari-code">
                      {item.cariCode || '-'}
                    </td>
                    <td data-label="Makine" className="priority">
                      {item['Makine İsmi'] || '-'}
                    </td>
                    <td data-label="Operatör" className="priority">
                      {item['Operatör Adı'] || '-'}
                    </td>
                    {userInfo.showPuantajPrice && (
                      <PuantajPriceCell puantajData={item} calculatePrice={calculatePuantajPrice} />
                    )}
                    <td data-label="Tarih" className="priority">
                      {item['Tarih'] ? formatTrDateOnly(item['Tarih']) : '-'}
                    </td>
                    <td data-label="Detaylar">
                      {renderWorkDetails(item)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination Controls */}
          {totalPages > 1 && (
            <div className="pagination-controls">
              <button 
                className="pagination-btn" 
                onClick={handlePreviousPage} 
                disabled={currentPage === 1}
              >
                ← Önceki
              </button>
              
              <div className="pagination-numbers">
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(pageNumber => {
                  // Sadece mevcut sayfa etrafındaki sayfaları göster
                  if (
                    pageNumber === 1 || 
                    pageNumber === totalPages || 
                    (pageNumber >= currentPage - 2 && pageNumber <= currentPage + 2)
                  ) {
                    return (
                      <button
                        key={pageNumber}
                        className={`pagination-number ${currentPage === pageNumber ? 'active' : ''}`}
                        onClick={() => handlePageChange(pageNumber)}
                      >
                        {pageNumber}
                      </button>
                    );
                  } else if (
                    pageNumber === currentPage - 3 || 
                    pageNumber === currentPage + 3
                  ) {
                    return <span key={pageNumber} className="pagination-dots">...</span>;
                  }
                  return null;
                })}
              </div>
              
              <button 
                className="pagination-btn" 
                onClick={handleNextPage} 
                disabled={currentPage === totalPages}
              >
                Sonraki →
              </button>
            </div>
          )}
        </>
      )}

      {selectedPdf && (
        <>
          <div className="pdf-popup-overlay" onClick={closePopup}></div>
          <div className="pdf-popup">
            <div className="pdf-header">
              <h3>{selectedPdf.name}</h3>
              <div className="pdf-header-buttons">
                <button 
                  className="download-button" 
                  onClick={async () => {
                    try {
                      // Fetch ile blob olarak al ve indir
                      const response = await fetch(selectedPdf.url);
                      const blob = await response.blob();
                      
                      // Blob URL oluştur ve indir
                      const blobUrl = window.URL.createObjectURL(blob);
                      const link = document.createElement('a');
                      link.href = blobUrl;
                      link.download = selectedPdf.name;
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                      
                      // Blob URL'yi temizle
                      window.URL.revokeObjectURL(blobUrl);
                    } catch (error) {
                      console.error('PDF indirme hatası:', error);
                      // Fallback: direkt link ile dene
                      const link = document.createElement('a');
                      link.href = selectedPdf.url;
                      link.download = selectedPdf.name;
                      link.target = '_blank';
                      link.click();
                    }
                  }}
                  title="PDF'i İndir"
                >
                  📥 İndir
                </button>
                <button className="close-button" onClick={closePopup} title="Kapat">×</button>
              </div>
            </div>
            <iframe
              src={`${selectedPdf.url}#toolbar=0&navpanes=0&scrollbar=0`}
              title={selectedPdf.name}
              width="100%"
              height="100%"
            />
          </div>
        </>
      )}

      {isHakedisPopupOpen && (
        <div className="modal" onClick={closeHakedisPopup}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Birim Saat Giriniz</h3>
            <input
              type="number"
              value={unitRate}
              onChange={(e) => setUnitRate(e.target.value)}
              placeholder="Birim Saat"
            />
            <div className="popup-total-hours">
              <p>Toplam Saat: {calculatedTotalHours}</p>
            </div>
            <button onClick={closeHakedisPopup} className="close-button">
              Kapat
            </button>
          </div>
        </div>
      )}

      {alertOpen && (
        <div className={`alert ${error ? 'alert-error' : 'alert-success'}`}>
          <span>{error || successMessage}</span>
          <button onClick={() => setAlertOpen(false)}>×</button>
        </div>
      )}

      {isDownloadModalOpen && <DownloadOptionsModal />}
      <EditPuantajModal
        open={isEditModalOpen}
        formData={editFormData}
        onChange={setEditFormData}
        formRefs={formRefs.current}
        isCustomerSelectionOpen={isCustomerSelectionOpen}
        toggleCustomerSelection={toggleCustomerSelection}
        allCustomers={allCustomersForSelection}
        handleSelectCustomer={handleSelectCustomerFromTable}
        onClose={handleCloseEditModal}
        onSubmit={handleEditSubmit}
        // Yeni prop'lar
        machineOptions={machineOptions}
        operatorOptions={operatorOptions}
        isMachineSelectionOpen={isMachineSelectionOpen}
        toggleMachineSelection={toggleMachineSelection}
        handleSelectMachine={handleSelectMachine}
        isOperatorSelectionOpen={isOperatorSelectionOpen}
        toggleOperatorSelection={toggleOperatorSelection}
        handleSelectOperator={handleSelectOperator}
      />
      <DeleteModal />
      <PDFLoadingModal />

      {/* PDF Preview Modal */}
      <PDFPreviewModal
        isOpen={isPdfPreviewOpen}
        onClose={() => setIsPdfPreviewOpen(false)}
        onApprove={handlePdfPreviewApprove}
        onReject={handlePdfPreviewReject}
        pdfUrl={previewPdfUrl}
        isGenerating={false} // Artık PDF hazır olduğunda modal açılıyor
        puantajData={pendingPuantajUpdate}
      />

      {/* Yeni Müşteri Ekleme Modal'ı */}
      <AddCustomerModal
        isOpen={isAddCustomerModalOpen}
        onClose={() => {
          setIsAddCustomerModalOpen(false);
          setNewCustomerFromPuantaj('');
        }}
        setAlertOpen={setAlertOpen}
        setError={setError}
        setSuccessMessage={setSuccessMessage}
        initialCustomerName={newCustomerFromPuantaj}
        onCustomerAdded={async () => {
          // Müşteri eklendikten sonra müşteri listesini yeniden yükle
          console.log('🔄 Yeni müşteri eklendi, müşteri listesi yeniden yükleniyor...');
          
          // Müşteri listesini yeniden yükle (customerOptions'ı güncelle)
          try {
            await fetchFilterData();
            console.log('✅ Müşteri listesi başarıyla yenilendi');
            
            // Müşteri ekleme modalını kapat
            setIsAddCustomerModalOpen(false);
            setNewCustomerFromPuantaj('');
            
            // Kullanıcıya bilgi ver
            setSuccessMessage('Müşteri başarıyla eklendi! Şimdi "Onayla ve Kaydet" butonuna tekrar basarak işlemi tamamlayabilirsiniz.');
            setAlertOpen(true);
            
            // Mesajı 3 saniye sonra temizle
            setTimeout(() => {
              setSuccessMessage('');
              setAlertOpen(false);
            }, 3000);
            
          } catch (error) {
            console.error('❌ Müşteri listesi yenileme hatası:', error);
            setError('Müşteri listesi yenilenemedi. Lütfen sayfayı yenileyin.');
            setAlertOpen(true);
          }
        }}
      />
    </div>
  );
};

// Puantaj fiyat hücre bileşeni
const PuantajPriceCell = ({ puantajData, calculatePrice }) => {
  const [price, setPrice] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchPrice = async () => {
      setLoading(true);
      try {
        const calculatedPrice = await calculatePrice(puantajData);
        setPrice(calculatedPrice);
      } catch (error) {
        console.error('Fiyat hesaplama hatası:', error);
        setPrice('Hata');
      } finally {
        setLoading(false);
      }
    };

    fetchPrice();
  }, [puantajData, calculatePrice]);

  return (
    <td data-label="💰 Fiyat" className="priority price-cell">
      {loading ? (
        <span className="price-loading">💫</span>
      ) : (
        <span className="price-value">
          {price || '-'}
        </span>
      )}
    </td>
  );
};

export default React.memo(Puantajlar);